// 第三方游戏 - 中文
const game_cn = {
  体育: '体育',
  视讯: '视讯',
  捕鱼: '捕鱼',
  电子: '电子',
  棋牌: '棋牌',
  真人: '真人',
  '789体育': '789体育',
  开元体育: '开元体育',
  FB体育: 'FB体育',
  PRETTY真人: 'PRETTY真人',
  AFB视讯: 'AFB视讯',
  SAGaming视讯: 'SAGaming视讯',
  完美真人: '完美真人',
  AESEXY真人: 'AESEXY真人',
  joker电子: 'joker电子',
  MT电子: 'MT电子',
  BNG电子: 'BNG电子',
  YGG电子: 'YGG电子',
  NEXTSPIN电子: 'NEXTSPIN电子',
  AFB电子: 'AFB电子',
  PGSOFT电子: 'PGSOFT电子',
  沙巴体育: '沙巴体育',
  "DB棋牌": "DB",
  Sexy体育: 'Sexy体育',
  SBO利记体育: 'SBO利记体育',
  皇冠体育: '皇冠体育',
  雷火电竞: '雷火电竞',
  SV388斗鸡: 'SV388斗鸡',
  TRC赛马: 'TRC赛马',
  EA板球: 'EA板球',
  IM体育: 'IM体育',
  IM电竞: 'IM电竞',
  DB电竞: 'DB电竞',
  IBO真人: 'IBO真人',
  GLG视讯: 'GLG视讯',
  EVO真人: 'EVO真人',
  EVO视讯: 'EVO视讯',
  AG真人: 'AG真人',
  BBIN视讯: 'BBIN视讯',
  DG真人: 'DG真人',
  BG视讯: 'BG视讯',
  MG视讯: 'MG视讯',
  欧博真人: '欧博真人',
  ebet真人: 'ebet真人',
  XG真人: 'XG真人',
  热门游戏: '热门游戏',
  CQ9捕鱼: 'CQ9捕鱼',
  百胜捕鱼: '百胜捕鱼',
  天游捕鱼: '天游捕鱼',
  大唐捕鱼: '大唐捕鱼',
  MG捕鱼: 'MG捕鱼',
  BG捕鱼大师: 'BG捕鱼大师',
  AG捕鱼王: 'AG捕鱼王',
  AG捕鱼: 'AG捕鱼',
  BG西游捕鱼: 'BG西游捕鱼',
  JDB捕鱼: 'JDB捕鱼',
  FG捕鱼: 'FG捕鱼',
  AGYP电子: 'AGYP电子',
  PP电子: 'PP电子',
  PG电子: 'PG电子',
  RT电子: 'RT电子',
  VT电子: 'VT电子',
  CQ9电子: 'CQ9电子',
  BBIN电子: 'BBIN电子',
  PT电子: 'PT电子',
  AG电子: 'AG电子',
  FG电子: 'FG电子',
  MG电子: 'MG电子',
  JDB电子: 'JDB电子',
  JDB夺宝电子: 'JDB夺宝电子',
  DT电子: 'DT电子',
  UPG电子: 'UPG电子',
  HC电子: 'HC电子',
  simpleplay电子: 'simpleplay电子',
  JILI电子: 'JILI电子',
  AMEBA电子: 'AMEBA电子',
  PS电子: 'PS电子',
  百胜棋牌: '百胜棋牌',
  财神棋牌: '财神棋牌',
  欢乐棋牌: '欢乐棋牌',
  新世界棋牌: '新世界棋牌',
  Kingmaker: 'Kingmaker',
  '365棋牌': '365棋牌',
  开元棋牌: '开元棋牌',
  乐游棋牌: '乐游棋牌',
  天游棋牌: '天游棋牌',
  博乐棋牌: '博乐棋牌',
  美博棋牌: '美博棋牌',
  FG棋牌: 'FG棋牌',
  王者棋牌: '王者棋牌',
  大唐棋牌: '大唐棋牌',
  JILI棋牌: 'JILI棋牌',
  找不到游戏: '找不到游戏',
  请勿频繁操作: '请勿频繁操作',
  游戏账户: '游戏账户',
  "总览": "总览",
  投注记录: '投注记录',
  投注时间: '投注时间',
  '游戏-注单': '游戏-注单',
  投注金额: '投注金额',
  已派奖: '已派奖',
  一键回收成功: '一键回收成功',
  一分钟只能回收一次: '一分钟只能回收一次',
  失败: '失败',
  成功: '成功',
  处理中: '处理中',
  返水优惠: '返水优惠',
  代理返点: '代理返点',
  余额转换: '余额转换',
  其它: '其它',
  账变明细: '账变明细',
  打码量扣减: '打码量扣减',
  洗码派送: '洗码派送',
  注单结算: '注单结算',
  下级用户: '下级用户',
  新结算派送: '新结算派送',
  第三方异常金币返还: '第三方异常金币返还',
  钱包到余额宝: '钱包到余额宝',
  余额宝到钱包: '余额宝到钱包',
  充值大礼包: '充值大礼包',
  分享领工资: '分享领工资',
  '充值优惠-渠道优惠': '充值优惠-渠道优惠',
  晋级奖励: '晋级奖励',
  周俸禄: '周俸禄',
  月俸禄: '月俸禄',
  签到奖金: '签到奖金',
  提现审核: '提现审核',
  提现拒绝: '提现拒绝',
  保底返还: '保底返还',
  和局返还: '和局返还',
  预存充值: '预存充值',
  充值返还: '充值返还',
  钱包到AG: '钱包到AG',
  AG到钱包: 'AG到钱包',
  钱包到开元棋牌: '钱包到开元棋牌',
  开元棋牌到钱包: '开元棋牌到钱包',
  钱包到乐游棋牌: '钱包到乐游棋牌',
  乐游棋牌到钱包: '乐游棋牌到钱包',
  立马高视讯到钱包: '立马高视讯到钱包',
  钱包到立马高视讯: '钱包到立马高视讯',
  JDB到钱包: 'JDB到钱包',
  钱包到JDB: '钱包到JDB',
  沙巴体育到钱包: '沙巴体育到钱包',
  钱包到沙巴体育: '钱包到沙巴体育',
  Sexy体育到钱包: 'Sexy体育到钱包',
  钱包到Sexy体育: '钱包到Sexy体育',
  王者棋牌到钱包: '王者棋牌到钱包',
  钱包到王者棋牌: '钱包到王者棋牌',
  大唐棋牌到钱包: '大唐棋牌到钱包',
  钱包到大唐棋牌: '钱包到大唐棋牌',
  BBIN到钱包: 'BBIN到钱包',
  钱包到BBIN: '钱包到BBIN',
  MG到钱包: 'MG到钱包',
  钱包到MG: '钱包到MG',
  IG电子游戏到钱包: 'IG电子游戏到钱包',
  钱包到IG电子游戏: '钱包到IG电子游戏',
  大富翁棋牌到钱包: '大富翁棋牌到钱包',
  钱包到大富翁棋牌: '钱包到大富翁棋牌',
  财神棋牌到钱包: '财神棋牌到钱包',
  钱包到财神棋牌: '钱包到财神棋牌',
  BG捕鱼到钱包: 'BG捕鱼到钱包',
  钱包到BG捕鱼: '钱包到BG捕鱼',
  欢乐棋牌到钱包: '欢乐棋牌到钱包',
  钱包到欢乐棋牌: '钱包到欢乐棋牌',
  天游到钱包: '天游到钱包',
  钱包到天游: '钱包到天游',
  天美棋牌到钱包: '天美棋牌到钱包',
  钱包到天美棋牌: '钱包到天美棋牌',
  博乐棋牌到钱包: '博乐棋牌到钱包',
  钱包到博乐棋牌: '钱包到博乐棋牌',
  BTI体育到钱包: 'BTI体育到钱包',
  钱包到BTI体育: '钱包到BTI体育',
  天境棋牌到钱包: '天境棋牌到钱包',
  钱包到天境棋牌: '钱包到天境棋牌',
  DG真人到钱包: 'DG真人到钱包',
  钱包到DG真人: '钱包到DG真人',
  百胜到钱包: '百胜到钱包',
  钱包到百胜: '钱包到百胜',
  红包返还: '红包返还',
  CQ9到钱包: 'CQ9到钱包',
  钱包到CQ9: '钱包到CQ9',
  BBIN电子到钱包: 'BBIN电子到钱包',
  钱包到BBIN电子: '钱包到BBIN电子',
  钱包到新世界棋牌: '钱包到新世界棋牌',
  新世界棋牌到钱包: '新世界棋牌到钱包',
  钱包到DT: '钱包到DT',
  DT到钱包: 'DT到钱包',
  BG视讯到钱包: 'BG视讯到钱包',
  钱包到BG视讯: '钱包到BG视讯',
  钱包到皇冠体育: '钱包到皇冠体育',
  皇冠体育到钱包: '皇冠体育到钱包',
  钱包到PT电子: '钱包到PT电子',
  PT电子到钱包: 'PT电子到钱包',
  钱包到胜博体育: '钱包到胜博体育',
  胜博体育到钱包: '胜博体育到钱包',
  钱包到美博棋牌: '钱包到美博棋牌',
  美博棋牌到钱包: '美博棋牌到钱包',
  钱包到QG红包: '钱包到QG红包',
  QG红包到钱包: 'QG红包到钱包',
  钱包到IG真人: '钱包到IG真人',
  IG真人到钱包: 'IG真人到钱包',
  钱包到欧博真人: '钱包到欧博真人',
  欧博真人到钱包: '欧博真人到钱包',
  钱包到雷火电竞: '钱包到雷火电竞',
  雷火电竞到钱包: '雷火电竞到钱包',
  钱包到IBO真人: '钱包到IBO真人',
  IBO真人到钱包: 'IBO真人到钱包',
  钱包到天成彩票: '钱包到天成彩票',
  钱包到S128斗鸡: '钱包到S128斗鸡',
  S128斗鸡到钱包: 'S128斗鸡到钱包',
  钱包到GPI彩票: '钱包到GPI彩票',
  GPI彩票到钱包: 'GPI彩票到钱包',
  钱包到kingmaker: '钱包到kingmaker',
  kingmaker到钱包: 'kingmaker到钱包',
  钱包到EVOPlay电子: '钱包到EVOPlay电子',
  EVOPlay电子到钱包: 'EVOPlay电子到钱包',
  钱包到PP电子: '钱包到PP电子',
  PP电子到钱包: 'PP电子到钱包',
  SV388斗鸡到钱包: 'SV388斗鸡到钱包',
  钱包到SV388斗鸡: '钱包到SV388斗鸡',
  钱包到kingpoker: '钱包到kingpoker',
  kingpoker到钱包: 'kingpoker到钱包',
  钱包到SBO利记体育: '钱包到SBO利记体育',
  SBO利记体育到钱包: 'SBO利记体育到钱包',
  钱包到PG电子: '钱包到PG电子',
  PG电子到钱包: 'PG电子到钱包',
  PG电子自身返点: 'PG电子自身返点',
  PG电子代理返点: 'PG电子代理返点',
  回水: '回水',
  取消回水: '取消回水',
  '充值优惠-手工': '充值优惠-手工',
  充值优惠: '充值优惠',
  '代理返点-手工': '代理返点-手工',
  '返水优惠-手工': '返水优惠-手工',
  其他: '其他',
  代理转账转入: '代理转账转入',
  普通转账: '普通转账',
  普通转账返还: '普通转账返还',
  代理转账转出: '代理转账转出',
  手工调整余额: '手工调整余额',
  手工充值: '手工充值',
  代理工资: '代理工资',
  代理分红: '代理分红',
  AG真人自身返点: 'AG真人自身返点',
  AG真人代理返点: 'AG真人代理返点',
  开元棋牌自身返点: '开元棋牌自身返点',
  乐游棋牌自身返点: '乐游棋牌自身返点',
  开元棋牌代理返点: '开元棋牌代理返点',
  乐游棋牌代理返点: '乐游棋牌代理返点',
  立马高视讯自身返点: '立马高视讯自身返点',
  立马高视讯代理返点: '立马高视讯代理返点',
  JDB电子自身返点: 'JDB电子自身返点',
  JDB电子代理返点: 'JDB电子代理返点',
  沙巴体育自身返点: '沙巴体育自身返点',
  沙巴体育代理返点: '沙巴体育代理返点',
  Sexy体育自身返点: 'Sexy体育自身返点',
  Sexy体育代理返点: 'Sexy体育代理返点',
  BBIN真人自身返点: 'BBIN真人自身返点',
  BBIN真人代理返点: 'BBIN真人代理返点',
  MG电子自身返点: 'MG电子自身返点',
  MG电子代理返点: 'MG电子代理返点',
  IG电子游戏自身返点: 'IG电子游戏自身返点',
  IG电子游戏代理返点: 'IG电子游戏代理返点',
  AG捕鱼自身返点: 'AG捕鱼自身返点',
  AG捕鱼代理返点: 'AG捕鱼代理返点',
  大富翁棋牌自身返点: '大富翁棋牌自身返点',
  大富翁棋牌代理返点: '大富翁棋牌代理返点',
  财神棋牌自身返点: '财神棋牌自身返点',
  财神棋牌代理返点: '财神棋牌代理返点',
  BG捕鱼自身返点: 'BG捕鱼自身返点',
  BG捕鱼代理返点: 'BG捕鱼代理返点',
  欢乐棋牌自身返点: '欢乐棋牌自身返点',
  欢乐棋牌代理返点: '欢乐棋牌代理返点',
  西游捕鱼自身返点: '西游捕鱼自身返点',
  西游捕鱼代理返点: '西游捕鱼代理返点',
  天游棋牌自身返点: '天游棋牌自身返点',
  天游棋牌代理返点: '天游棋牌代理返点',
  天美棋牌自身返点: '天美棋牌自身返点',
  天美棋牌代理返点: '天美棋牌代理返点',
  博乐棋牌自身返点: '博乐棋牌自身返点',
  博乐棋牌代理返点: '博乐棋牌代理返点',
  BIT体育自身返点: 'BIT体育自身返点',
  BIT体育代理返点: 'BIT体育代理返点',
  MG捕鱼自身返点: 'MG捕鱼自身返点',
  MG捕鱼代理返点: 'MG捕鱼代理返点',
  JDB捕鱼自身返点: 'JDB捕鱼自身返点',
  JDB捕鱼代理返点: 'JDB捕鱼代理返点',
  天游捕鱼自身返点: '天游捕鱼自身返点',
  天游捕鱼代理返点: '天游捕鱼代理返点',
  百胜棋牌自身返点: '百胜棋牌自身返点',
  百胜棋牌代理返点: '百胜棋牌代理返点',
  王者棋牌自身返点: '王者棋牌自身返点',
  王者棋牌代理返点: '王者棋牌代理返点',
  开通大唐棋牌: '开通大唐棋牌',
  大唐棋牌自身返点: '大唐棋牌自身返点',
  大唐棋牌代理返点: '大唐棋牌代理返点',
  DG真人自身返点: 'DG真人自身返点',
  DG真人代理返点: 'DG真人代理返点',
  开通TRC赛马: '开通TRC赛马',
  钱包到TRC赛马: '钱包到TRC赛马',
  TRC赛马到钱包: 'TRC赛马到钱包',
  TRC赛马自身返点: 'TRC赛马自身返点',
  TRC赛马代理返点: 'TRC赛马代理返点',
  开通365棋牌: '开通365棋牌',
  钱包到365棋牌: '钱包到365棋牌',
  '365棋牌到钱包': '365棋牌到钱包',
  '365棋牌自身返点': '365棋牌自身返点',
  '365棋牌代理返点': '365棋牌代理返点',
  开通XG真人: '开通XG真人',
  钱包到XG真人: '钱包到XG真人',
  XG真人到钱包: 'XG真人到钱包',
  XG真人自身返点: 'XG真人自身返点',
  XG真人代理返点: 'XG真人代理返点',
  开通EVO真人: '开通EVO真人',
  钱包到EVO真人: '钱包到EVO真人',
  EVO真人到钱包: 'EVO真人到钱包',
  EVO真人自身返点: 'EVO真人自身返点',
  EVO真人代理返点: 'EVO真人代理返点',
  ebet真人自身返点: 'ebet真人自身返点',
  ebet真人代理返点: 'ebet真人代理返点',
  开通ebet真人: '开通ebet真人',
  钱包到ebet真人: '钱包到ebet真人',
  ebet真人到钱包: 'ebet真人到钱包',
  ebet真人自助返水类型: 'ebet真人自助返水类型',
  新世界棋牌自身返点: '新世界棋牌自身返点',
  新世界棋牌代理返点: '新世界棋牌代理返点',
  天境棋牌自身返点: '天境棋牌自身返点',
  天境棋牌代理返点: '天境棋牌代理返点',
  BG真人自身返点: 'BG真人自身返点',
  BG真人代理返点: 'BG真人代理返点',
  百胜捕鱼自身返点: '百胜捕鱼自身返点',
  百胜捕鱼代理返点: '百胜捕鱼代理返点',
  钱包到大唐捕鱼: '钱包到大唐捕鱼',
  大唐捕鱼到钱包: '大唐捕鱼到钱包',
  大唐捕鱼自身返点: '大唐捕鱼自身返点',
  大唐捕鱼代理返点: '大唐捕鱼代理返点',
  DT电子自身返点: 'DT电子自身返点',
  DT电子代理返点: 'DT电子代理返点',
  CQ9电子自身返点: 'CQ9电子自身返点',
  CQ9电子代理返点: 'CQ9电子代理返点',
  CQ9捕鱼自身返点: 'CQ9捕鱼自身返点',
  CQ9捕鱼代理返点: 'CQ9捕鱼代理返点',
  BG视讯自身返点: 'BG视讯自身返点',
  BG视讯代理返点: 'BG视讯代理返点',
  MG视讯自身返点: 'MG视讯自身返点',
  MG视讯代理返点: 'MG视讯代理返点',
  PT电子自身返点: 'PT电子自身返点',
  PT电子代理返点: 'PT电子代理返点',
  AG电子自身返点: 'AG电子自身返点',
  AG电子代理返点: 'AG电子代理返点',
  AGYP电子自身返点: 'AGYP电子自身返点',
  AGYP电子代理返点: 'AGYP电子代理返点',
  BBIN电子自身返点: 'BBIN电子自身返点',
  BBIN电子代理返点: 'BBIN电子代理返点',
  红包雨红包: '红包雨红包',
  皇冠体育自身返点: '皇冠体育自身返点',
  皇冠体育代理返点: '皇冠体育代理返点',
  胜博体育自身返点: '胜博体育自身返点',
  胜博体育代理返点: '胜博体育代理返点',
  美博棋牌自身返点: '美博棋牌自身返点',
  美博棋牌代理返点: '美博棋牌代理返点',
  QG红包自身返点: 'QG红包自身返点',
  QG红包代理返点: 'QG红包代理返点',
  IG真人自身返点: 'IG真人自身返点',
  IG真人代理返点: 'IG真人代理返点',
  欧博真人自身返点: '欧博真人自身返点',
  欧博真人代理返点: '欧博真人代理返点',
  雷火电竞自身返点: '雷火电竞自身返点',
  雷火电竞代理返点: '雷火电竞代理返点',
  IBO真人自身返点: 'IBO真人自身返点',
  IBO真人代理返点: 'IBO真人代理返点',
  S128斗鸡自身返点: 'S128斗鸡自身返点',
  S128斗鸡代理返点: 'S128斗鸡代理返点',
  GPI彩票自身返点: 'GPI彩票自身返点',
  GPI彩票代理返点: 'GPI彩票代理返点',
  kingmaker自身返点: 'kingmaker自身返点',
  kingmaker代理返点: 'kingmaker代理返点',
  EVOPlay电子自身返点: 'EVOPlay电子自身返点',
  EVOPlay电子代理返点: 'EVOPlay电子代理返点',
  PP电子自身返点: 'PP电子自身返点',
  SBO利记体育个人返点: 'SBO利记体育个人返点',
  SBO利记体育代理返点: 'SBO利记体育代理返点',
  PP电子代理返点: 'PP电子代理返点',
  kingpoker自身返点: 'kingpoker自身返点',
  kingpoker代理返点: 'kingpoker代理返点',
  负盈利代理返点: '负盈利代理返点',
  充值代理返点: '充值代理返点',
  自助返水: '自助返水',
  UPG到钱包: 'UPG到钱包',
  钱包到UPG: '钱包到UPG',
  奖金派送: '奖金派送',
  钱包到FG: '钱包到FG',
  FG到钱包: 'FG到钱包',
  开通JILI: '开通JILI',
  钱包到JILI: '钱包到JILI',
  JILI到钱包: 'JILI到钱包',
  JILI电子自身返点: 'JILI电子自身返点',
  JILI电子代理返点: 'JILI电子代理返点',
  JILI棋牌自身返点: 'JILI棋牌自身返点',
  JILI棋牌代理返点: 'JILI棋牌代理返点',
  开通EA板球: '开通EA板球',
  钱包到EA板球: '钱包到EA板球',
  EA板球到钱包: 'EA板球到钱包',
  EA板球自身返点: 'EA板球自身返点',
  EA板球代理返点: 'EA板球代理返点',
  开通IM体育: '开通IM体育',
  IM体育投注扣款: 'IM体育投注扣款',
  IM体育注单结算: 'IM体育注单结算',
  IM体育自身返点: 'IM体育自身返点',
  IM体育代理返点: 'IM体育代理返点',
  开通IM电竞: '开通IM电竞',
  IM电竞投注扣款: 'IM电竞投注扣款',
  IM电竞投注结算: 'IM电竞投注结算',
  IM电竞自身返点: 'IM电竞自身返点',
  IM电竞代理返点: 'IM电竞代理返点',
  开通DB电竞: '开通DB电竞',
  DB电竞投注扣款: 'DB电竞投注扣款',
  DB电竞投注结算: 'DB电竞投注结算',
  DB电竞自身返点: 'DB电竞自身返点',
  DB电竞代理返点: 'DB电竞代理返点',
  开通PS电子: '开通PS电子',
  钱包到PS电子: '钱包到PS电子',
  PS电子到钱包: 'PS电子到钱包',
  PS电子自身返点: 'PS电子自身返点',
  PS电子代理返点: 'PS电子代理返点',
  开通VT电子: '开通VT电子',
  钱包到VT电子: '钱包到VT电子',
  VT电子到钱包: 'VT电子到钱包',
  VT电子自身返点: 'VT电子自身返点',
  VT电子代理返点: 'VT电子代理返点',
  开通RT电子: '开通RT电子',
  钱包到RT电子: '钱包到RT电子',
  RT电子到钱包: 'RT电子到钱包',
  RT电子自身返点: 'RT电子自身返点',
  RT电子代理返点: 'RT电子代理返点',
  开通AMEBA电子: '开通AMEBA电子',
  钱包到Ameba电子: '钱包到Ameba电子',
  Ameba电子到钱包: 'Ameba电子到钱包',
  Ameba电子自身返点: 'Ameba电子自身返点',
  Ameba电子代理返点: 'Ameba电子代理返点',
  开通SIMPLEPLAY电子: '开通SIMPLEPLAY电子',
  钱包到SIMPLEPLAY电子: '钱包到SIMPLEPLAY电子',
  SIMPLEPLAY电子到钱包: 'SIMPLEPLAY电子到钱包',
  SimplePlay电子自身返点: 'SimplePlay电子自身返点',
  SimplePlay电子代理返点: 'SimplePlay电子代理返点',
  FG电子自身返点: 'FG电子自身返点',
  FG电子代理返点: 'FG电子代理返点',
  FG捕鱼自身返点: 'FG捕鱼自身返点',
  FG捕鱼代理返点: 'FG捕鱼代理返点',
  FG棋牌自身返点: 'FG棋牌自身返点',
  FG棋牌代理返点: 'FG棋牌代理返点',
  钱包到GLG视讯: '钱包到GLG视讯',
  GLG视讯到钱包: 'GLG视讯到钱包',
  GLG视讯自身返点: 'GLG视讯自身返点',
  GLG视讯代理返点: 'GLG视讯代理返点',
  异常加减分: '异常加减分',
  上一级返佣: '上一级返佣',
  上二级返佣: '上二级返佣',
  上三级返佣: '上三级返佣',
  钱包到HC电子: '钱包到HC电子',
  HC电子到钱包: 'HC电子到钱包',
  投注扣款: '投注扣款',
  进入第三方游戏: '进入第三方游戏',
  看牌抢牛超变看四张王者场: '看牌抢牛超变看四张王者场',
  看牌抢牛刺激看四张新手场: '看牌抢牛刺激看四张新手场',
  看牌抢牛刺激看四张至尊场: '看牌抢牛刺激看四张至尊场',
  看牌抢牛刺激看四张王者场: '看牌抢牛刺激看四张王者场',
  通比牛牛经典新手场: '通比牛牛经典新手场',
  通比牛牛经典初级场: '通比牛牛经典初级场',
  通比牛牛经典中级场: '通比牛牛经典中级场',
  通比牛牛经典高级场: '通比牛牛经典高级场',
  通比牛牛经典至尊场: '通比牛牛经典至尊场',
  通比牛牛经典王者场: '通比牛牛经典王者场',
  看牌抢牛经典看三张新手场: '看牌抢牛经典看三张新手场',
  看牌抢牛经典看三张初级场: '看牌抢牛经典看三张初级场',
  看牌抢牛经典看三张中级场: '看牌抢牛经典看三张中级场',
  看牌抢牛经典看三张高级场: '看牌抢牛经典看三张高级场',
  炸金花体验房: '炸金花体验房',
  炸金花初级房: '炸金花初级房',
  炸金花中级房: '炸金花中级房',
  炸金花高级房: '炸金花高级房',
  看牌抢牛超变看四张中级场: '看牌抢牛超变看四张中级场',
  看牌抢牛超变看四张高级场: '看牌抢牛超变看四张高级场',
  看牌抢牛超变看四张至尊场: '看牌抢牛超变看四张至尊场',
  极速炸金花新手房: '极速炸金花新手房',
  极速炸金花初级房: '极速炸金花初级房',
  极速炸金花中级房: '极速炸金花中级房',
  极速炸金花高级房: '极速炸金花高级房',
  高级场: '高级场',
  中级场: '中级场',
  初级场: '初级场',
  德州扑克新手房: '德州扑克新手房',
  德州扑克初级房: '德州扑克初级房',
  德州扑克中级房: '德州扑克中级房',
  德州扑克高级房: '德州扑克高级房',
  幸运五张体验房: '幸运五张体验房',
  幸运五张初级房: '幸运五张初级房',
  幸运五张中级房: '幸运五张中级房',
  幸运五张高级房: '幸运五张高级房',
  抢庄骰宝体验房: '抢庄骰宝体验房',
  抢庄骰宝初级房: '抢庄骰宝初级房',
  抢庄骰宝中级房: '抢庄骰宝中级房',
  抢庄骰宝高级房: '抢庄骰宝高级房',
  '21点体验房': '21点体验房',
  '21点初级房': '21点初级房',
  '21点中级房': '21点中级房',
  '21点高级房': '21点高级房',
  十三水常规场新手房: '十三水常规场新手房',
  十三水常规场初级房: '十三水常规场初级房',
  十三水常规场中级房: '十三水常规场中级房',
  十三水常规场高级房: '十三水常规场高级房',
  十三水极速场新手房: '十三水极速场新手房',
  十三水极速场初级房: '十三水极速场初级房',
  十三水极速场中级房: '十三水极速场中级房',
  十三水极速场高级房: '十三水极速场高级房',
  斗地主体验房: '斗地主体验房',
  斗地主初级房: '斗地主初级房',
  斗地主中级房: '斗地主中级房',
  斗地主高级房: '斗地主高级房',
  斗地主王者房: '斗地主王者房',
  斗地主至尊房: '斗地主至尊房',
  二八杠体验房: '二八杠体验房',
  二八杠初级房: '二八杠初级房',
  二八杠中级房: '二八杠中级房',
  二八杠高级房: '二八杠高级房',
  二八杠至尊房: '二八杠至尊房',
  二八杠王者房: '二八杠王者房',
  抢庄牌九新手房: '抢庄牌九新手房',
  抢庄牌九初级房: '抢庄牌九初级房',
  抢庄牌九中级房: '抢庄牌九中级房',
  抢庄牌九高级房: '抢庄牌九高级房',
  抢庄牌九至尊房: '抢庄牌九至尊房',
  抢庄牌九王者房: '抢庄牌九王者房',
  抢庄牛牛体验房: '抢庄牛牛体验房',
  抢庄牛牛初级房: '抢庄牛牛初级房',
  抢庄牛牛中级房: '抢庄牛牛中级房',
  抢庄牛牛高级房: '抢庄牛牛高级房',
  抢庄牛牛至尊房: '抢庄牛牛至尊房',
  抢庄牛牛王者房: '抢庄牛牛王者房',
  三公体验房: '三公体验房',
  三公初级房: '三公初级房',
  三公中级房: '三公中级房',
  三公高级房: '三公高级房',
  三公至尊房: '三公至尊房',
  三公王者房: '三公王者房',
  通比牛牛体验房: '通比牛牛体验房',
  通比牛牛初级房: '通比牛牛初级房',
  通比牛牛中级房: '通比牛牛中级房',
  通比牛牛高级房: '通比牛牛高级房',
  通比牛牛至尊房: '通比牛牛至尊房',
  看三张抢庄牛牛体验房: '看三张抢庄牛牛体验房',
  看三张抢庄牛牛初级房: '看三张抢庄牛牛初级房',
  看三张抢庄牛牛中级房: '看三张抢庄牛牛中级房',
  看三张抢庄牛牛高级房: '看三张抢庄牛牛高级房',
  看三张抢庄牛牛至尊房: '看三张抢庄牛牛至尊房',
  看三张抢庄牛牛王者房: '看三张抢庄牛牛王者房',
  龙虎体验房: '龙虎体验房',
  龙虎初级房: '龙虎初级房',
  龙虎中级房: '龙虎中级房',
  龙虎高级房: '龙虎高级房',
  百家乐体验房: '百家乐体验房',
  百家乐初级房: '百家乐初级房',
  百家乐中级房: '百家乐中级房',
  百家乐高级房: '百家乐高级房',
  森林舞会体验房: '森林舞会体验房',
  森林舞会初级房: '森林舞会初级房',
  森林舞会中级房: '森林舞会中级房',
  森林舞会高级房: '森林舞会高级房',
  百人牛牛体验房: '百人牛牛体验房',
  百人牛牛初级房: '百人牛牛初级房',
  百人牛牛中级房: '百人牛牛中级房',
  百人牛牛高级房: '百人牛牛高级房',
  经典斗地主比赛: '经典斗地主比赛',
  梭哈牛牛新手房: '梭哈牛牛新手房',
  梭哈牛牛初级房: '梭哈牛牛初级房',
  梭哈牛牛中级房: '梭哈牛牛中级房',
  梭哈牛牛高级房: '梭哈牛牛高级房',
  抢庄牛牛十倍新手场: '抢庄牛牛十倍新手场',
  抢庄牛牛十倍初级场: '抢庄牛牛十倍初级场',
  抢庄牛牛十倍至尊场: '抢庄牛牛十倍至尊场',
  抢庄牛牛十倍王者场: '抢庄牛牛十倍王者场',
  抢庄牛牛三倍新手场: '抢庄牛牛三倍新手场',
  抢庄牛牛三倍初级场: '抢庄牛牛三倍初级场',
  抢庄牛牛三倍中级场: '抢庄牛牛三倍中级场',
  抢庄牛牛三倍高级场: '抢庄牛牛三倍高级场',
  抢庄牛牛三倍至尊场: '抢庄牛牛三倍至尊场',
  抢庄牛牛三倍王者场: '抢庄牛牛三倍王者场',
  抢庄牛牛百变新手场: '抢庄牛牛百变新手场',
  抢庄牛牛百变初级场: '抢庄牛牛百变初级场',
  抢庄牛牛百变王者场: '抢庄牛牛百变王者场',
  通比牛牛三倍新手场: '通比牛牛三倍新手场',
  通比牛牛三倍初级场: '通比牛牛三倍初级场',
  通比牛牛三倍高级场: '通比牛牛三倍高级场',
  通比牛牛三倍中级场: '通比牛牛三倍中级场',
  运气牛牛百变新手场: '运气牛牛百变新手场',
  通比牛牛三倍至尊场: '通比牛牛三倍至尊场',
  通比牛牛三倍王者场: '通比牛牛三倍王者场',
  通比牛牛十倍新手场: '通比牛牛十倍新手场',
  通比牛牛十倍初级场: '通比牛牛十倍初级场',
  通比牛牛十倍中级场: '通比牛牛十倍中级场',
  通比牛牛十倍高级场: '通比牛牛十倍高级场',
  通比牛牛十倍至尊场: '通比牛牛十倍至尊场',
  通比牛牛十倍王者场: '通比牛牛十倍王者场',
  通比牛牛百变新手场: '通比牛牛百变新手场',
  通比牛牛百变初级场: '通比牛牛百变初级场',
  通比牛牛百变中级场: '通比牛牛百变中级场',
  通比牛牛百变高级场: '通比牛牛百变高级场',
  通比牛牛百变至尊场: '通比牛牛百变至尊场',
  通比牛牛百变王者场: '通比牛牛百变王者场',
  通杀牛牛经典新手场: '通杀牛牛经典新手场',
  通杀牛牛经典初级场: '通杀牛牛经典初级场',
  通杀牛牛经典中级场: '通杀牛牛经典中级场',
  通杀牛牛经典高级场: '通杀牛牛经典高级场',
  通杀牛牛经典至尊场: '通杀牛牛经典至尊场',
  通杀牛牛经典王者场: '通杀牛牛经典王者场',
  通杀牛牛三倍新手场: '通杀牛牛三倍新手场',
  通杀牛牛三倍初级场: '通杀牛牛三倍初级场',
  通杀牛牛三倍中级场: '通杀牛牛三倍中级场',
  通杀牛牛三倍高级场: '通杀牛牛三倍高级场',
  通杀牛牛三倍至尊场: '通杀牛牛三倍至尊场',
  通杀牛牛三倍王者场: '通杀牛牛三倍王者场',
  通杀牛牛十倍新手场: '通杀牛牛十倍新手场',
  通杀牛牛十倍初级场: '通杀牛牛十倍初级场',
  通杀牛牛十倍中级场: '通杀牛牛十倍中级场',
  通杀牛牛十倍高级场: '通杀牛牛十倍高级场',
  通杀牛牛十倍至尊场: '通杀牛牛十倍至尊场',
  通杀牛牛十倍王者场: '通杀牛牛十倍王者场',
  通杀牛牛百变新手场: '通杀牛牛百变新手场',
  通杀牛牛百变初级场: '通杀牛牛百变初级场',
  通杀牛牛百变中级场: '通杀牛牛百变中级场',
  通杀牛牛百变高级场: '通杀牛牛百变高级场',
  通杀牛牛百变至尊场: '通杀牛牛百变至尊场',
  通杀牛牛百变王者场: '通杀牛牛百变王者场',
  运气牛牛三倍新手场: '运气牛牛三倍新手场',
  运气牛牛三倍初级场: '运气牛牛三倍初级场',
  运气牛牛三倍中级场: '运气牛牛三倍中级场',
  运气牛牛三倍高级场: '运气牛牛三倍高级场',
  运气牛牛三倍至尊场: '运气牛牛三倍至尊场',
  运气牛牛三倍王者场: '运气牛牛三倍王者场',
  运气牛牛十倍新手场: '运气牛牛十倍新手场',
  运气牛牛十倍初级场: '运气牛牛十倍初级场',
  运气牛牛十倍中级场: '运气牛牛十倍中级场',
  运气牛牛十倍高级场: '运气牛牛十倍高级场',
  运气牛牛十倍至尊场: '运气牛牛十倍至尊场',
  运气牛牛十倍王者场: '运气牛牛十倍王者场',
  抢庄牛牛6张经典新手场: '抢庄牛牛6张经典新手场',
  抢庄牛牛6张经典初级场: '抢庄牛牛6张经典初级场',
  抢庄牛牛6张经典中级场: '抢庄牛牛6张经典中级场',
  抢庄牛牛6张经典高级场: '抢庄牛牛6张经典高级场',
  抢庄牛牛6张经典至尊场: '抢庄牛牛6张经典至尊场',
  抢庄牛牛6张经典王者场: '抢庄牛牛6张经典王者场',
  抢庄牛牛6张百变王者场: '抢庄牛牛6张百变王者场',
  抢庄牛牛6张百变新手场: '抢庄牛牛6张百变新手场',
  抢庄牛牛6张百变初级场: '抢庄牛牛6张百变初级场',
  抢庄牛牛6张百变中级场: '抢庄牛牛6张百变中级场',
  抢庄牛牛6张百变高级场: '抢庄牛牛6张百变高级场',
  抢庄牛牛6张百变至尊场: '抢庄牛牛6张百变至尊场',
  抢庄牛牛6张十倍新手场: '抢庄牛牛6张十倍新手场',
  抢庄牛牛6张十倍初级场: '抢庄牛牛6张十倍初级场',
  抢庄牛牛6张十倍中级场: '抢庄牛牛6张十倍中级场',
  抢庄牛牛6张十倍高级场: '抢庄牛牛6张十倍高级场',
  抢庄牛牛6张十倍至尊场: '抢庄牛牛6张十倍至尊场',
  抢庄牛牛6张十倍王者场: '抢庄牛牛6张十倍王者场',
  抢庄牛牛6张三倍新手场: '抢庄牛牛6张三倍新手场',
  抢庄牛牛6张三倍初级场: '抢庄牛牛6张三倍初级场',
  抢庄牛牛6张三倍中级场: '抢庄牛牛6张三倍中级场',
  抢庄牛牛6张三倍高级场: '抢庄牛牛6张三倍高级场',
  抢庄牛牛6张三倍至尊场: '抢庄牛牛6张三倍至尊场',
  抢庄牛牛6张三倍王者场: '抢庄牛牛6张三倍王者场',
  炸金花新手场: '炸金花新手场',
  炸金花初级场: '炸金花初级场',
  炸金花中级场: '炸金花中级场',
  炸金花高级场: '炸金花高级场',
  抢庄牛牛十倍中级场: '抢庄牛牛十倍中级场',
  抢庄牛牛十倍高级场: '抢庄牛牛十倍高级场',
  抢庄牛牛经典新手场: '抢庄牛牛经典新手场',
  抢庄牛牛经典初级场: '抢庄牛牛经典初级场',
  抢庄牛牛经典中级场: '抢庄牛牛经典中级场',
  抢庄牛牛经典高级场: '抢庄牛牛经典高级场',
  抢庄牛牛经典至尊场: '抢庄牛牛经典至尊场',
  抢庄牛牛经典王者场: '抢庄牛牛经典王者场',
  抢庄牛牛百变中级场: '抢庄牛牛百变中级场',
  抢庄牛牛百变高级场: '抢庄牛牛百变高级场',
  抢庄牛牛百变至尊场: '抢庄牛牛百变至尊场',
  疯狂点子牛初级场: '疯狂点子牛初级场',
  疯狂点子牛中级场: '疯狂点子牛中级场',
  疯狂点子牛高级场: '疯狂点子牛高级场',
  疯狂点子牛至尊场: '疯狂点子牛至尊场',
  疯狂点子牛王者场: '疯狂点子牛王者场',
  彩金牛牛初级场: '彩金牛牛初级场',
  彩金牛牛中级场: '彩金牛牛中级场',
  彩金牛牛高级场: '彩金牛牛高级场',
  彩金牛牛至尊场: '彩金牛牛至尊场',
  彩金牛牛王者场: '彩金牛牛王者场',
  看四张抢庄牛牛体验房: '看四张抢庄牛牛体验房',
  看四张抢庄牛牛初级房: '看四张抢庄牛牛初级房',
  看四张抢庄牛牛中级房: '看四张抢庄牛牛中级房',
  看四张抢庄牛牛高级房: '看四张抢庄牛牛高级房',
  看四张抢庄牛牛至尊房: '看四张抢庄牛牛至尊房',
  骰宝体验房: '骰宝体验房',
  骰宝初级房: '骰宝初级房',
  骰宝中级房: '骰宝中级房',
  骰宝高级房: '骰宝高级房',
};
// 电子子游戏的翻译
const electronic_cn = {
  维京纪元: '维京纪元',
  美食美刻: '美食美刻',
  金钱兔: '金钱兔',
  假面嘉年华: '假面嘉年华',
  足球小子: '足球小子',
  热血足球: '热血足球',
  四龙: '四龙',
  亚洲四虎: '亚洲四虎',
  黄金蟹: '黄金蟹',
  金龍发发: '金龍发发',
  黄金岛: '黄金岛',
  金猴王: '金猴王',
  金鲨: '金鲨',
  伟大蓝海: '伟大蓝海',
  笑弥勒: '笑弥勒',
  快乐矿工: '快乐矿工',
  欢乐节庆: '欢乐节庆',
  高速之冠: '高速之冠',
  高速之冠连线: '高速之冠连线',
  野蛮世界: '野蛮世界',
  葫芦: '葫芦',
  虫虫乐园: '虫虫乐园',
  森林岛冒险记: '森林岛冒险记',
  经典德比赛马: '经典德比赛马',
  舞狮共舞: '舞狮共舞',
  海洋之王: '海洋之王',
  吉鼓发财: '吉鼓发财',
  财神连线: '财神连线',
  财神发发发2: '财神发发发2',
  幸运女神护身符豪华版: '幸运女神护身符豪华版',
  财富熊猫: '财富熊猫',
  幸运鸡: '幸运鸡',
  幸运轮盘: '幸运轮盘',
  单人幸运轮盘: '单人幸运轮盘',
  幸运转盘: '幸运转盘',
  妈妈咪呀: '妈妈咪呀',
  迈阿密: '迈阿密',
  金库: '金库',
  西部警长: '西部警长',
  决战天下: '决战天下',
  战无不胜: '战无不胜',
  齐天大圣2: '齐天大圣2',
  猴子爬树3D: '猴子爬树3D',
  花木兰: '花木兰',
  神秘之沙: '神秘之沙',
  海王宝藏: '海王宝藏',
  金块猎人: '金块猎人',
  海洋天堂: '海洋天堂',
  八角形宝石: '八角形宝石',
  八角形宝石2: '八角形宝石2',
  潘金莲: '潘金莲',
  熊猫大侠: '熊猫大侠',
  黑豹的月亮: '黑豹的月亮',
  蟠桃会: '蟠桃会',
  凤凰转世888: '凤凰转世888',
  航海王: '航海王',
  博町: '博町',
  超级巨星: '超级巨星',
  女王: '女王',
  尼罗河女王: '尼罗河女王',
  FNG战争: 'FNG战争',
  疯狂旋转: '疯狂旋转',
  羅賓漢: '羅賓漢',
  热血探险记: '热血探险记',
  探险非洲: '探险非洲',
  圣诞惊喜: '圣诞惊喜',
  银子弹: '银子弹',
  银子弹连线: '银子弹连线',
  泼水节: '泼水节',
  斯巴达: '斯巴达',
  速度女王: '速度女王',
  超级赛马: '超级赛马',
  超级龙王: '超级龙王',
  超龙3D: '超龙3D',
  至尊财神: '至尊财神',
  太上老君: '太上老君',
  皇家同花顺: '皇家同花顺',
  泰国风情: '泰国风情',
  四大发明: '四大发明',
  三太子传奇: '三太子传奇',
  虚拟百家乐: '虚拟百家乐',
  百搭大熊猫: '百搭大熊猫',
  荒野守护者: '荒野守护者',
  百搭的精神: '百搭的精神',
  世界之树: '世界之树',
  僵尸国土: '僵尸国土',
  焰龍88: '焰龍88',
  古代宝石: '古代宝石',
  三湖称霸: '三湖称霸',
  '888龍传说': '888龍传说',
  龍之领域: '龍之领域',
  幸运小丑: '幸运小丑',
  玛雅宝石: '玛雅宝石',
  命运之火: '命运之火',
  虎穴: '虎穴',
  火龍帝国: '火龍帝国',
  超级星球: '超级星球',
  甜蜜冬季: '甜蜜冬季',
  财务佳节: '财务佳节',
  阿兹台克神庙: '阿兹台克神庙',
  八宝钱袋: '八宝钱袋',
  赏金猎人: '赏金猎人',
  网络竞赛: '网络竞赛',
  海洋浪花: '海洋浪花',
  '辣椒狼人 宾果': '辣椒狼人 宾果',
  少林: '少林',
  亡灵节: '亡灵节',
  森林宝藏: '森林宝藏',
  西方神话: '西方神话',
  巫师: '巫师',
  黄金猎者: '黄金猎者',
  热带水果: '热带水果',
  凤凰: '凤凰',
  法老之墓: '法老之墓',
  绿洲: '绿洲',
  欢迎来到农场主的财富: '欢迎来到农场主的财富',
  圣诞老人工作坊: '圣诞老人工作坊',
  古罗马: '古罗马',
  护身符: '护身符',
  抢劫: '抢劫',
  三国2: '三国2',
  皇后2: '皇后2',
  爱丽丝移游仙境: '爱丽丝移游仙境',
  番摊: '番摊',
  百家乐宝贝: '百家乐宝贝',
  虚拟骰宝: '虚拟骰宝',
  决战篮球: '决战篮球',
  '白联赛-数字王': '白联赛-数字王',
  虚拟轮盘: '虚拟轮盘',
  大小: '大小',
  越南鱼虾蟹: '越南鱼虾蟹',
  足球狂热: '足球狂热',
  巴厘岛: '巴厘岛',
  芝加哥街头: '芝加哥街头',
  黑帮: '黑帮',
  精灵2: '精灵2',
  疯狂小动物: '疯狂小动物',
  英雄联盟: '英雄联盟',
  财神爷: '财神爷',
  潘金莲2: '潘金莲2',
  新白娘子: '新白娘子',
  罗马传奇: '罗马传奇',
  满者伯夷: '满者伯夷',
  海盗: '海盗',
  超级幸运象: '超级幸运象',
  生肖宾果: '生肖宾果',
  诅咒Deluxe: '诅咒Deluxe',
  '777超级BIG BuildUp™豪华版™': '777超级BIG BuildUp™豪华版™',
  '777绝对豪华': '777绝对豪华',
  喜喜: '喜喜',
  龍之火焰: '龍之火焰',
  天方夜谭: '天方夜谭',
  夏日水果: '夏日水果',
  葉賢: '葉賢',
  水果之夏: '水果之夏',
  加密躁狂者宾果: '加密躁狂者宾果',
  海王宾果: '海王宾果',
  羅馬竞技场: '羅馬竞技场',
  拳击: '拳击',
  荷鲁斯之眼: '荷鲁斯之眼',
  鹰夫人: '鹰夫人',
  拳击2: '拳击2',
  诅咒: '诅咒',
  大財神: '大財神',
  至尊珠宝: '至尊珠宝',
  幸运条纹: '幸运条纹',
  火烧珍珠: '火烧珍珠',
  '大財神 宾果': '大財神 宾果',
  葉賢Deluxe: '葉賢Deluxe',
  玩命之徒: '玩命之徒',
  欲望魅影: '欲望魅影',
  可爱女巫: '可爱女巫',
  森林探险记: '森林探险记',
  无尽: '无尽',
  仙女百搭: '仙女百搭',
  闪电神: '闪电神',
  疯狂小丑: '疯狂小丑',
  魔法森林: '魔法森林',
  巫师Deluxe: '巫师Deluxe',
  加密躁狂者: '加密躁狂者',
  '狂欢夜': '狂欢夜',
  '爱丽思': '爱丽思',
  '古代神器': '古代神器',
  '天使&恶魔': '天使&恶魔',
  '动物派对': '动物派对',
  '弓箭手': '弓箭手',
  '北极宝藏': '北极宝藏',
  '乐爆彩': '乐爆彩',
  '阿兹特克金字塔': '阿兹特克金字塔',
  '八卦': '八卦',
  '八卦2': '八卦2',
  '魔豆': '魔豆',
  '鸟王争霸:飞鼠御天': '鸟王争霸:飞鼠御天',
  '熊之舞': '熊之舞',
  '圣约之书': '圣约之书',
  '圣约之书豪华版': '圣约之书豪华版',
  '火焰珍珠宾果': '火焰珍珠宾果',
  '武士道': '武士道',
  '罗杰船长': '罗杰船长',
  '宝藏船长': '宝藏船长',
  '藏宝船长加强版': '藏宝船长加强版',
  '藏宝船长连线': '藏宝船长连线',
  '加勒比萨迦': '加勒比萨迦',
  '兑现或崩盘': '兑现或崩盘',
  '辣椒猎人': '辣椒猎人',
  '中国': '中国',
  '大富豪': '大富豪',
  '瘋狂水果派對': '瘋狂水果派對',
  '哥伦布': '哥伦布',
  '恐龙猎人新王龙觉醒': '恐龙猎人新王龙觉醒',
  '海豚世界': '海豚世界',
  '海豚宝藏': '海豚宝藏',
  '海豚的珍珠豪华版': '海豚的珍珠豪华版',
  '东海龙王': '东海龙王',
  '龙传奇': '龙传奇',
  '炸彈王': '炸彈王',
  '进入KTV': '进入KTV',
  '发财财神': '发财财神',
  '黄金双龙': '黄金双龙',
  '50金狮': '50金狮',
  '星際獵人': '星際獵人',
  '怪物奇谈': '怪物奇谈',
  '海王': '海王',
  '海王-金龍崛起': '海王-金龍崛起',
  '海王2': '海王2',
  '海王2Ex - 好友吧': '海王2Ex - 好友吧',
  '海王2Ex - 新手': '海王2Ex - 新手',
  '海王2Ex-初手': '海王2Ex-初手',
  '海王2Ex-专手': '海王2Ex-专手',
  '海霸': '海霸',
  '海王3': '海王3',
  '海绵宝宝': '海绵宝宝',
  '龙宫': '龙宫',
  '大圣闹海': '大圣闹海',
  '金蟾埔鱼': '金蟾埔鱼',
  '开心捕鱼5': '开心捕鱼5',
  '海王4凤凰传说': '海王4凤凰传说',
  '鱼 虾 蟹': '鱼 虾 蟹',
  '雷电猎人': '雷电猎人',
  '渔人码头': '渔人码头',
  '五龙吐珠': '五龙吐珠',
  '锦鲤报喜': '锦鲤报喜',
  '金龍發發': '金龍發發',
  '黃金岛': '黃金岛',
  '笑彌勒': '笑彌勒',
  '快樂礦工': '快樂礦工',
  '舞獅共舞': '舞獅共舞',
  '媽媽咪呀': '媽媽咪呀',
  '邁阿密': '邁阿密',
  '齊天大聖': '齊天大聖',
  '花木蘭': '花木蘭',
  '鳳凰轉世888': '鳳凰轉世888',
  '瘋狂旋轉': '瘋狂旋轉',
  'RNG战争': 'RNG战争',
  '紅火暴擊': '紅火暴擊',
  '古代寶石': '古代寶石',
  '小丑珠寶': '小丑珠寶',
  '三虎稱霸': '三虎稱霸',
  '888龍傳說': '888龍傳說',
  '龍之領域': '龍之領域',
  '幸運小丑': '幸運小丑',
  '瑪雅寶石': '瑪雅寶石',
  '命運之火': '命運之火',
  '火龍帝國': '火龍帝國',
  '超級星球': '超級星球',
  '財富佳節': '財富佳節',
  '阿茲台克神廟': '阿茲台克神廟',
  '八寶錢袋': '八寶錢袋',
  '辣椒獵人 宾果': '辣椒獵人 宾果',
  '亡靈節': '亡靈節',
  '西方神話': '西方神話',
  '黃金獵者': '黃金獵者',
  '熱帶水果': '熱帶水果',
  '番 摊': '番 摊',
  '百练赛-数字王': '百练赛-数字王',
  '大 小': '大 小',
  '財神爺': '財神爺',
  '超级大亨': '超级大亨',
  'ATT金皇冠': 'ATT金皇冠',
  '大满贯水果机': '大满贯水果机',
  '泰山闯天关2': '泰山闯天关2',
  '不倒翁': '不倒翁',
  '醉西游': '醉西游',
  '延禧攻略': '延禧攻略',
  '三只小猪': '三只小猪',
  '年年有鱼': '年年有鱼',
  '天空之神': '天空之神',
  '武媚娘传奇': '武媚娘传奇',
  '萝卜跳一跳': '萝卜跳一跳',
  '宫心计': '宫心计',
  '新潘金莲': '新潘金莲',
  '宫本武藏': '宫本武藏',
  '水浒传豪华版': '水浒传豪华版',
  '金钱豹水果机': '金钱豹水果机',
  '福星献舞': '福星献舞',
  "骆马大冒险": "骆马大冒险",
  "金鸡福彩": "金鸡福彩",
  "魔法乳神": "魔法乳神",
  "宝石物语": "宝石物语",
  "七海夺宝": "七海夺宝",
  "幸运龙": "幸运龙",
  "唐伯虎点秋香": "唐伯虎点秋香",
  "变脸": "变脸",
  "悟空": "悟空",
  "台湾黑熊": "台湾黑熊",
  "幸运麟": "幸运麟",
  "招财狮": "招财狮",
  "月光秘宝": "月光秘宝",
  "上班族狂想曲": "上班族狂想曲",
  "过新年": "过新年",
  "拿破仑": "拿破仑",
  "文房四宝": "文房四宝",
  "芝麻开门": "芝麻开门",
  "黄金香蕉帝国": "黄金香蕉帝国",
  "麻雀无双": "麻雀无双",
  "奥林匹亚神庙": "奥林匹亚神庙",
  "水晶王国": "水晶王国",
  "神偷妙贼": "神偷妙贼",
  "热舞教父": "热舞教父",
  "料理厨王": "料理厨王",
  "幸运淘金鼠": "幸运淘金鼠",
  "奇幻糖果岛": "奇幻糖果岛",
  "疯狂科学家": "疯狂科学家",
  "金饺子": "金饺子",
  "金钱侠": "金钱侠",
  "幸运凤": "幸运凤",
  "龙王": "龙王",
  "魔术秀": "魔术秀",
  "江山美人": "江山美人",
  "关公": "关公",
  "变脸2": "变脸2",
  "芝麻开门2": "芝麻开门2",
  "唐伯虎点秋香2": "唐伯虎点秋香2",
  "马上有钱": "马上有钱",
  "斗鸡": "斗鸡",
  "玛雅大冒险": "玛雅大冒险",
  "屌丝熊猫": "屌丝熊猫",
  "塞尔达传说": "塞尔达传说",
  "包大人": "包大人",
  "亿万富翁": "亿万富翁",
  "一拳超人": "一拳超人",
  "神龙大侠": "神龙大侠",
  "飞龙在天": "飞龙在天",
  "银河护卫队": "银河护卫队",
  "街头霸王": "街头霸王",
  "春宵苦短": "春宵苦短",
  "星球大战": "星球大战",
  "王牌特工": "王牌特工",
  "少女前线": "少女前线",
  "妲己": "妲己",
  "钱滚钱": "钱滚钱",
  "采矿土豪": "采矿土豪",
  "赌王扑克": "赌王扑克",
  "幸运赛车": "幸运赛车",
  "发大财": "发大财",
  "好运777": "好运777",
  "东方神兽": "东方神兽",
  "三倍金刚": "三倍金刚",
  "飞鸟派对": "飞鸟派对",
  "狗来富": "狗来富",
  "龙舞": "龙舞",
  "超级牛B": "超级牛B",
  "埃及夺宝": "埃及夺宝",
  "开运夺宝": "开运夺宝",
  "雷神之锤": "雷神之锤",
  "聚宝盆": "聚宝盆",
  "金鸡报囍": "金鸡报囍",
  "齐天大圣": "齐天大圣",
  "火牛阵": "火牛阵",
  "幸运福娃": "幸运福娃",
  "印加帝国": "印加帝国",
  "忍者大进击": "忍者大进击",
  "熊猫厨王": "熊猫厨王",
  "后羿传": "后羿传",
  "五福临门": "五福临门",
  "九尾狐": "九尾狐",
  "小玛莉": "小玛莉",
  "新年快乐": "新年快乐",
  "飞禽走兽": "飞禽走兽",
  "啤酒大亨": "啤酒大亨",
  "花果山传奇": "花果山传奇",
  "超激发水果盘": "超激发水果盘",
  "财神宾果": "财神宾果",
  "快乐六星彩": "快乐六星彩",
  "金刚": "金刚",
  "富豪哥": "富豪哥",
  "喜洋羊": "喜洋羊",
  "乒乓巨星": "乒乓巨星",
  "神秘的梦": "神秘的梦",
  "瑞维拉财宝": "瑞维拉财宝",
  "歌剧魅影": "歌剧魅影",
  "烈焰面具": "烈焰面具",
  "龙母财富": "龙母财富",
  "冰球突破幸运百搭": "冰球突破幸运百搭",
  "幸运双星大奖": "幸运双星大奖",
  "逃宝街机游戏": "逃宝街机游戏",
  "丛林吉姆失落的狮身人面像": "丛林吉姆失落的狮身人面像",
  "幸运单身族": "幸运单身族",
  "108好汉": "108好汉",
  "侠盗猎车手": "侠盗猎车手",
  "A&8 红利5PK": "A&8 红利5PK",
  "秘密行动-雪诺和塞布尔": "秘密行动-雪诺和塞布尔",
  "冒险丛林(HD)": "冒险丛林(HD)",
  "大航海时代": "大航海时代",
  "城市猎人": "城市猎人",
  "特工简.布隆德归来": "特工简.布隆德归来",
  "阿拉斯加垂钓": "阿拉斯加垂钓",
  "Zeus古代财富": "Zeus古代财富",
  "爱丽娜": "爱丽娜",
  "亚洲风情": "亚洲风情",
  "金牌大西洋城21点": "金牌大西洋城21点",
  "极光百搭": "极光百搭",
  "香蕉奥德赛": "香蕉奥德赛",
  "黑绵羊咩咩叫": "黑绵羊咩咩叫",
  "条条纹纹": "条条纹纹",
  "篮球巨星": "篮球巨星",
  "篮球巨星豪华版": "篮球巨星豪华版",
  "大逃杀": "大逃杀",
  "沙滩女孩": "沙滩女孩",
  "森林之王": "森林之王",
  "马戏团": "马戏团",
  "比基尼派对": "比基尼派对",
  "摇滚怪兽": "摇滚怪兽",
  "Oz之书锁定并旋转": "Oz之书锁定并旋转",
  "冰球突破": "冰球突破",
  "冰球突破豪华版": "冰球突破豪华版",
  "银行抢匪": "银行抢匪",
  "银行抢匪2": "银行抢匪2",
  "再抢银行再旋转": "再抢银行再旋转",
  "丛林快讯": "丛林快讯",
  "抢银行": "抢银行",
  "梦果子乐园": "梦果子乐园",
  "富贵王国": "富贵王国",
  "昆虫派对": "昆虫派对",
  "现金咖啡": "现金咖啡",
  "现金威乐": "现金威乐",
  "城堡建筑师2": "城堡建筑师2",
  "网球冠军": "网球冠军",
  "经典243": "经典243",
  "运财酷儿": "运财酷儿",
  "酷派狼人": "酷派狼人",
  "慵懒土豆": "慵懒土豆",
  "板球明星": "板球明星",
  "水晶裂谷": "水晶裂谷",
  "德科钻石": "德科钻石",
  "钻石帝国": "钻石帝国",
  "海豚海岸": "海豚海岸",
  "海豚历奇": "海豚历奇",
  "四倍红利5PK": "四倍红利5PK",
  "舞龙": "舞龙",
  "神龙碎片": "神龙碎片",
  "幸运龙宝贝": "幸运龙宝贝",
  "夢幻邂逅": "梦幻邂逅",
  "疾风老鹰": "疾风老鹰",
  "表情金币": "表情金币",
  "青龙出海": "青龙出海",
  "金牌欧洲21点": "金牌欧洲21点",
  "异域狂兽": "异域狂兽",
  "海底派对": "海底派对",
  "足球之巅": "足球之巅",
  "金库甜心": "金库甜心",
  "财富之都": "财富之都",
  "水果大爆发": "水果大爆发",
  "水果vs糖果": "水果vs糖果",
  "宝石奥德赛": "宝石奥德赛",
  "巨人财富": "巨人财富",
  "美女枪手丛林激战": "美女枪手丛林激战",
  "黄金工厂": "黄金工厂",
  "黄金时代": "黄金时代",
  "万圣节派对": "万圣节派对",
  "快乐假日": "快乐假日",
  "开心娃娃机": "开心娃娃机",
  "哈维斯的晚餐": "哈维斯的晚餐",
  "地狱怪客": "地狱怪客",
  "挑战者": "挑战者",
  "圣诞企鹅": "圣诞企鹅",
  "酷犬酒店": "酷犬酒店",
  "轩辕帝传": "轩辕帝传",
  "不朽情缘": "不朽情缘",
  "对J高手5PK": "对J高手5PK",
  "丛林吉姆黄金国": "丛林吉姆黄金国",
  "侏罗纪世界": "侏罗纪世界",
  "K歌乐韵": "K歌乐韵",
  "加德满都": "加德满都",
  "大象之王": "大象之王",
  "现金之王": "现金之王",
  "凯蒂卡巴拉": "凯蒂卡巴拉",
  "淑女派对": "淑女派对",
  "罗拉卡芙特之神庙古墓": "罗拉卡芙特之神庙古墓",
  "传奇keno": "传奇keno",
  "奔月传说": "奔月传说",
  "富裕人生": "富裕人生",
  "狮子的自尊": "狮子的自尊",
  "液态黄金": "液态黄金",
  "摔角传奇": "摔角传奇",
  "招财鞭炮": "招财鞭炮",
  "幸运妖精": "幸运妖精",
  "宝贝财神": "宝贝财神",
  "幸运双星": "幸运双星",
  "幸运生肖": "幸运生肖",
  "魔力撒哈拉": "魔力撒哈拉",
  "百万富翁5线": "百万富翁5线",
  "终结侵略者": "终结侵略者",
  "巨额现金乘数": "巨额现金乘数",
  "巨款大冲击": "巨款大冲击",
  "百万钞票": "百万钞票",
  "大白鲸": "大白鲸",
  "怪物赛车": "怪物赛车",
  "有你的校园": "有你的校园",
  "派对岛屿": "派对岛屿",
  "躲猫猫": "躲猫猫",
  "狂野宠物": "狂野宠物",
  "持枪王者": "持枪王者",
  "Playboy 黄金": "Playboy 黄金",
  "Playboy黃金大奖": "Playboy黄金大奖",
  "进击的猿人": "进击的猿人",
  "漂亮猫咪": "漂亮猫咪",
  "白金俱乐部": "白金俱乐部",
  "水晶射线女王": "水晶射线女王",
  "帽中的兔子": "帽中的兔子",
  "旋转大战": "旋转大战",
  "真正高手": "真正高手",
  "雷霆风暴": "雷霆风暴",
  "探陵人": "探陵人",
  "经典老虎机": "经典老虎机",
  "鑽石浮华": "钻石浮华",
  "酷热经典": "酷热经典",
  "乔治与柏志": "乔治与柏志",
  "女皇之心": "女皇之心",
  "罗曼诺夫财富": "罗曼诺夫财富",
  "橄榄球明星": "橄榄球明星",
  "冰雪圣诞村": "冰雪圣诞村",
  "小气财神": "小气财神",
  "暗恋": "暗恋",
  "秘密爱慕者": "秘密爱慕者",
  "伦敦的夏洛克": "伦敦的夏洛克",
  "时界门之将军": "时界门之将军",
  "对决沙龙": "对决沙龙",
  "银狼": "银狼",
  "银色雌狮4x": "银色雌狮4x",
  "杂技群英会": "杂技群英会",
  "好多怪兽": "好多怪兽",
  "好多糖果": "好多糖果",
  "好多寿司": "好多寿司",
  "春假时光": "春假时光",
  "星光之吻": "星光之吻",
  "泰坦帝国": "泰坦帝国",
  "纯银": "纯银",
  "暑假": "暑假",
  "暑假时光": "暑假时光",
  "追寻太阳": "追寻太阳",
  "太阳征程": "太阳征程",
  "增强马力": "增强马力",
  "必胜": "必胜",
  "狐狸爵士": "狐狸爵士",
  "泰山传奇": "泰山传奇",
  "至尊人生": "至尊人生",
  "探险之旅": "探险之旅",
  "伟大魔术师": "伟大魔术师",
  "极速抢钱": "极速抢钱",
  "鼠帮": "鼠帮",
  "奇妙马戏团": "奇妙马戏团",
  "雷神": "雷神",
  "雷霆万钧2": "雷霆万钧2",
  "虎眼": "虎眼",
  "蒂基维京": "蒂基维京",
  "古墓奇兵": "古墓奇兵",
  "古墓奇兵2": "古墓奇兵2",
  "尼罗河宝藏": "尼罗河宝藏",
  "宝藏宫殿": "宝藏宫殿",
  "海底宝城": "海底宝城",
  "野生熊猫": "野生熊猫",
  "黄金拉斯维加斯大道": "黄金拉斯维加斯大道",
  "型男舞步": "型男舞步",
  "黑胶热舞": "黑胶热舞",
  "哈啰巴黎": "哈啰巴黎",
  "囧囧熊猫": "囧囧熊猫",
  "猫头鹰乐园": "猫头鹰乐园",
  "黑暗故事: 神秘深红": "黑暗故事: 神秘深红",
  "东方珍兽": "东方珍兽",
  "百搭圣甲虫": "百搭圣甲虫",
  "丧尸来袭": "丧尸来袭",
  "花花公子": "花花公子",
  "足球明星豪华版": "足球明星豪华版",
  "金鸡报囍2": "金鸡报囍2",
  "火神": "火神",
  "宝石配对": "宝石配对",
  "跳高高": "跳高高",
  "跳起来": "跳起来",
  "跳更高": "跳更高",
  "鸿福齐天": "鸿福齐天",
  "武圣": "武圣",
  "飞起来": "飞起来",
  "宙斯": "宙斯",
  "蹦迪": "蹦迪",
  "跳高高2": "跳高高2",
  "跳起来2": "跳起来2",
  "发财神": "发财神",
  "直式蹦迪": "直式蹦迪",
  "直式武圣": "直式武圣",
  "火之女王": "火之女王",
  "跳过来": "跳过来",
  "单手跳高高": "单手跳高高",
  "金鸡报喜": "金鸡报喜",
  "钟馗运财": "钟馗运财",
  "嗨起来": "嗨起来",
  "金鸡报囍3": "金鸡报囍3",
  "六颗糖": "六颗糖",
  "东方神起": "东方神起",
  "花开富贵": "花开富贵",
  "宙斯他爹": "宙斯他爹",
  "甜蜜蜜": "甜蜜蜜",
  "发财神2": "发财神2",
  "水世界": "水世界",
  "直式洪福齐天": "直式洪福齐天",
  "火烧连环船2": "火烧连环船2",
  "冰雪女王": "冰雪女王",
  "变色龙": "变色龙",
  "直式宙斯": "直式宙斯",
  "丛林舞会": "丛林舞会",
  "转大钱": "转大钱",
  "飞天财神": "飞天财神",
  "好运年年": "好运年年",
  "哪吒再临": "哪吒再临",
  "直式跳更高": "直式跳更高",
  "火烧连环船": "火烧连环船",
  "单手跳起來": "单手跳起来",
  "发财福娃": "发财福娃",
  "梦游仙境": "梦游仙境",
  "直式发财神": "直式发财神",
  "大力神": "大力神",
  "双飞": "双飞",
  "狼月": "狼月",
  "五行": "五行",
  "拳霸": "拳霸",
  "金大款": "金大款",
  "五形拳": "五形拳",
  "直式五福临门": "直式五福临门",
  "黯夜公爵": "黯夜公爵",
  "血之吻": "血之吻",
  "赚金蛋": "赚金蛋",
  "金玉满堂": "金玉满堂",
  "寿星大发": "寿星大发",
  "舞媚娘": "舞媚娘",
  "神兽争霸": "神兽争霸",
  "五福临门JP": "五福临门JP",
  "金元宝": "金元宝",
  "阿波罗": "阿波罗",
  "钻更多": "钻更多",
  "龙舟": "龙舟",
  "豪华水果王": "豪华水果王",
  "火草泥马": "火草泥马",
  "直式火烧连环船": "直式火烧连环船",
  "森林泰后": "森林泰后",
  "印加祖玛": "印加祖玛",
  "世界杯明星": "世界杯明星",
  "奔跑吧猛兽": "奔跑吧猛兽",
  "直式跳起来2": "直式跳起来2",
  "悟空偷桃": "悟空偷桃",
  "祥狮献瑞": "祥狮献瑞",
  "飞天": "飞天",
  "发发发": "发发发",
  "万饱龙": "万饱龙",
  "钻饱宝": "钻饱宝",
  "魔龙传奇": "魔龙传奇",
  "九连宝灯": "九连宝灯",
  "老司机": "老司机",
  "海滨消消乐": "海滨消消乐",
  "风火轮": "风火轮",
  "寻龙诀": "寻龙诀",
  "家里有矿": "家里有矿",
  "偷金妹子": "偷金妹子",
  "水果派对": "水果派对",
  "印金工厂": "印金工厂",
  "盗法老墓": "盗法老墓",
  "火凤凰": "火凤凰",
  "金银岛": "金银岛",
  "牛逼快跑": "牛逼快跑",
  "聚宝盆JP": "聚宝盆JP",
  "水球大战": "水球大战",
  "锁象无敌": "锁象无敌",
  "狄仁杰四大天王": "狄仁杰四大天王",
  "福尔摩斯": "福尔摩斯",
  "五鬼运财": "五鬼运财",
  "棋圣": "棋圣",
  "火爆777": "火爆777",
  "莲": "莲",
  "疯狂哪咤": "疯狂哪咤",
  "宾果消消消": "宾果消消消",
  "雀王": "雀王",
  "汪财进宝": "汪财进宝",
  "天天吃豆": "天天吃豆",
  "僵尸的宝藏": "僵尸的宝藏",
  "直式金鸡报喜": "直式金鸡报喜",
  "再喵一个": "再喵一个",
  "三国序": "三国序",
  "舞力全开": "舞力全开",
  "梦游仙境2": "梦游仙境2",
  "金喜鹊桥": "金喜鹊桥",
  "来电99": "来电99",
  "斗地主升级版": "斗地主升级版",
  "直式金鸡报囍2": "直式金鸡报囍2",
  "镖王争霸": "镖王争霸",
  "寂寞星球": "寂寞星球",
  "星星消消乐": "星星消消乐",
  "法老宝藏": "法老宝藏",
  "集电宝": "集电宝",
  "此地无银300两": "此地无银300两",
  "五运": "五运",
  "超级发": "超级发",
  "囍": "囍",
  "世界杯全明星": "世界杯全明星",
  "美女与野兽": "美女与野兽",
  "奇幻魔术": "奇幻魔术",
  "地鼠战役": "地鼠战役",
  "传奇海神": "传奇海神",
  "旺旺旺": "旺旺旺",
  "恭贺新禧": "恭贺新禧",
  "嗨爆大马戏": "嗨爆大马戏",
  "妙笔生财": "妙笔生财",
  "喵财进宝": "喵财进宝",
  "樱花妹子": "樱花妹子",
  "8级台风": "8级台风",
  "魔法世界": "魔法世界",
  "足球宝贝": "足球宝贝",
  "转珠猪": "转珠猪",
  "赚金蛋JP": "赚金蛋JP",
  "夏日猩情": "夏日猩情",
  "扑克拉霸": "扑克拉霸",
  "通天神探狄仁杰": "通天神探狄仁杰",
  "麻将小福星": "麻将小福星",
  "百宝箱": "百宝箱",
  "点石成金": "点石成金",
  "守株待兔": "守株待兔",
  "世界杯球衣": "世界杯球衣",
  "圣诞来啦": "圣诞来啦",
  "斗地主经典版": "斗地主经典版",
  "鹊桥": "鹊桥",
  "鱼跃龙门": "鱼跃龙门",
  "世界杯球鞋": "世界杯球鞋",
  "绝赢巫师": "绝赢巫师",
  "黄金玛雅": "黄金玛雅",
  "食神": "食神",
  "世界杯球场": "世界杯球场",
  "隔壁王二不曾偷": "隔壁王二不曾偷",
  "宝莲灯": "宝莲灯",
  "财运亨通": "财运亨通",
  "富贵金鸡": "富贵金鸡",
  "八仙传奇": "八仙传奇",
  "马戏团连连发": "马戏团连连发",
  "2018世界杯": "2018世界杯",
  "夜店大亨": "夜店大亨",
  "妈祖传奇": "妈祖传奇",
  "爱琴海": "爱琴海",
  "生肖传奇": "生肖传奇",
  "丛林宝藏": "丛林宝藏",
  "庶务西游二课": "庶务西游二课",
  "丧尸大餐": "丧尸大餐",
  "野狼传说": "野狼传说",
  "运气靴": "运气靴",
  "贪吃猫": "贪吃猫",
  "喵喵": "喵喵",
  "财富幽灵": "财富幽灵",
  "火烧办公处": "火烧办公处",
  "猪的运气": "猪的运气",
  "驯龙高手": "驯龙高手",
  "幸运3": "幸运3",
  "塞特的宝藏": "塞特的宝藏",
  "幸运传奇": "幸运传奇",
  "功夫小神通": "功夫小神通",
  "疯狂软糖": "疯狂软糖",
  "足球世界杯": "足球世界杯",
  "疯狂马戏团": "疯狂马戏团",
  "厕所囧境": "厕所囧境",
  "异外来客": "异外来客",
  "圣诞故事": "圣诞故事",
  "好莱坞宠物": "好莱坞宠物",
  "死亡女王": "死亡女王",
  "雷神2": "雷神2",
  "疯狂赚钞票": "疯狂赚钞票",
  "上海再次旋转": "上海再次旋转",
  "钻石水果王": "钻石水果王",
  "有如神柱": "有如神柱",
  "非常钻": "非常钻",
  "四驱英雄": "四驱英雄",
  "十字路口": "十字路口",
  "仙侠情缘": "仙侠情缘",
  "赛亚烈战": "赛亚烈战",
  "灌篮大师": "灌篮大师",
  "格斗之魂": "格斗之魂",
  "赤壁之战": "赤壁之战",
  "NINJA": "NINJA",
  "灌篮大师2": "灌篮大师2",
  "海盗无双": "海盗无双",
  "圣域传说": "圣域传说",
  "财神到": "财神到",
  "新年到": "新年到",
  "武松传": "武松传",
  "封神榜": "封神榜",
  "西游降妖": "西游降妖",
  "白蛇传": "白蛇传",
  "龙凤呈祥": "龙凤呈祥",
  "英雄荣耀": "英雄荣耀",
  "福禄寿": "福禄寿",
  "四圣兽": "四圣兽",
  "3D老虎机": "3D老虎机",
  "传奇之路": "传奇之路",
  "摇滚之夜": "摇滚之夜",
  "深蓝海域": "深蓝海域",
  "圣战骑士": "圣战骑士",
  "嘻哈侠": "嘻哈侠",
  "海盗宝藏": "海盗宝藏",
  "幕府风云": "幕府风云",
  "圣诞快乐": "圣诞快乐",
  "倾城四美": "倾城四美",
  "甜蜜糖果屋": "甜蜜糖果屋",
  "曲艺大秀场": "曲艺大秀场",
  "夜影传说": "夜影传说",
  "全能侦探": "全能侦探",
  "满堂红": "满堂红",
  "雷霆神域": "雷霆神域",
  "萌宠小窝": "萌宠小窝",
  "热血街头": "热血街头",
  "铁拳擂台": "铁拳擂台",
  "精灵王国": "精灵王国",
  "埃及帝国": "埃及帝国",
  "火锅盛宴": "火锅盛宴",
  "大魔术师": "大魔术师",
  "大亨小传": "大亨小传",
  "银河战争": "银河战争",
  "逍遥骑士": "逍遥骑士",
  "深夜食堂": "深夜食堂",
  "寻宝之旅": "寻宝之旅",
  "法兰西风情": "法兰西风情",
  "阿拉丁愿望": "阿拉丁愿望",
  "小小大花园": "小小大花园",
  "丛林探险": "丛林探险",
  "荣耀风云": "荣耀风云",
  "疯狂炼金师": "疯狂炼金师",
  "3D娃娃机": "3D娃娃机",
  "古潼京": "古潼京",
  "乱斗三国": "乱斗三国",
  "魔性表情包": "魔性表情包",
  "冰火之歌": "冰火之歌",
  "地鼠嘎嘣脆": "地鼠嘎嘣脆",
  "魔豆传奇": "魔豆传奇",
  "美味西餐厅": "美味西餐厅",
  "赌场大亨": "赌场大亨",
  "秘密约会": "秘密约会",
  "心动女主播": "心动女主播",
  "野蛮战国": "野蛮战国",
  "数字大转轮": "数字大转轮",
  "夜上海": "夜上海",
  "祖玛帝国": "祖玛帝国",
  "惑星战记": "惑星战记",
  "外星战记": "外星战记",
  "外星争霸": "外星争霸",
  "传统": "传统",
  "丛林": "丛林",
  "FIFA2010": "FIFA2010",
  "水果乐园": "水果乐园",
  "功夫龙": "功夫龙",
  "幸运财神": "幸运财神",
  "鱼虾蟹": "鱼虾蟹",
  "钻石水果盘": "钻石水果盘",
  "森林舞会": "森林舞会",
  "斗魂": "斗魂",
  "爆骰": "爆骰",
  "疯狂水果盘": "疯狂水果盘",
  "超级7": "超级7",
  "龙在囧途": "龙在囧途",
  "水果拉霸": "水果拉霸",
  "筒子拉霸": "筒子拉霸",
  "足球拉霸": "足球拉霸",
  "酷搜马戏团": "酷搜马戏团",
  "水果擂台": "水果擂台",
  "水果大转轮": "水果大转轮",
  "3D数字大转轮": "3D数字大转轮",
  "乐透转轮": "乐透转轮",
  "钻石列车": "钻石列车",
  "圣兽传说": "圣兽传说",
  "斗大": "斗大",
  "红狗": "红狗",
  "金瓶梅": "金瓶梅",
  "金瓶梅2": "金瓶梅2",
  "海底世界": "海底世界",
  "金狗旺岁": "金狗旺岁",
  "七夕": "七夕",
  "欧式轮盘": "欧式轮盘",
  "三国": "三国",
  "美式轮盘": "美式轮盘",
  "彩金轮盘": "彩金轮盘",
  "法式轮盘": "法式轮盘",
  "神秘岛": "神秘岛",
  "女娲补天": "女娲补天",
  "奥林帕斯": "奥林帕斯",
  "球球大作战": "球球大作战",
  "绝地求生": "绝地求生",
  "多福多财": "多福多财",
  "夹猪珠": "夹猪珠",
  "熊猫乐园": "熊猫乐园",
  "啤酒嘉年华": "啤酒嘉年华",
  "斗牛赢家": "斗牛赢家",
  "魔光幻音": "魔光幻音",
  "糖果派对3": "糖果派对3",
  "情人夜": "情人夜",
  "步步高升": "步步高升",
  "糖果派": "糖果派",
  "宝石传奇": "宝石传奇",
  "Jenga": "Jenga",
  "埃及传奇": "埃及传奇",
  "初音大进击": "初音大进击",
  "东海龙宫": "东海龙宫",
  "三元四喜": "三元四喜",
  "雷神索尔": "雷神索尔",
  "2014FIFA": "2014FIFA",
  "夜市人生": "夜市人生",
  "沙滩排球": "沙滩排球",
  "大红帽与小野狼": "大红帽与小野狼",
  "秘境冒险": "秘境冒险",
  "阿兹特克宝藏": "阿兹特克宝藏",
  "凯萨帝国": "凯萨帝国",
  "航海时代": "航海时代",
  "恶龙传说": "恶龙传说",
  "霸王龙": "霸王龙",
  "喜福牛年": "喜福牛年",
  "喜福猴年": "喜福猴年",
  "经典高球": "经典高球",
  "连环夺宝": "连环夺宝",
  "糖果派对": "糖果派对",
  "秦皇秘宝": "秦皇秘宝",
  "蒸气炸弹": "蒸气炸弹",
  "趣味台球": "趣味台球",
  "糖果派对2": "糖果派对2",
  "开心消消乐": "开心消消乐",
  "魔法元素": "魔法元素",
  "连环夺宝2": "连环夺宝2",
  "好事成双": "好事成双",
  "牛运当头": "牛运当头",
  "黎利": "黎利",
  "偏财神": "偏财神",
  "满天星": "满天星",
  "莲花": "莲花",
  "金蟾吐珠": "金蟾吐珠",
  "招财进宝": "招财进宝",
  "蒸汽王国": "蒸汽王国",
  "月狼": "月狼",
  "金鸡报囍2020": "金鸡报囍2020",
  "海底传奇": "海底传奇",
  "中国好声音": "中国好声音",
  "葫芦娃": "葫芦娃",
  "马到成功": "马到成功",
  "开心蛋": "开心蛋",
  "战神": "战神",
  "糖果派对-极速版": "糖果派对-极速版",
  "回转寿司": "回转寿司",
  "疯狂麦斯": "疯狂麦斯",
  "猪宝满满": "猪宝满满",
  "电音之王": "电音之王",
  "大话西游": "大话西游",
  "金刚爬楼": "金刚爬楼",
  "Staronic": "Staronic",
  "明星97II": "明星97II",
  "猴子爬树": "猴子爬树",
  "明星97": "明星97",
  "抖音DJ": "抖音DJ",
  "大丰收": "大丰收",
  "急冻世界": "急冻世界",
  "诙谐财富": "诙谐财富",
  "龙龙龙": "龙龙龙",
  "众神时代:风暴之神TM": "众神时代:风暴之神TM",
  "夜间外出": "夜间外出",
  "仙境冒险": "仙境冒险",
  "神的时代": "神的时代",
  "神灵时代 : 命运姐妹": "神灵时代 : 命运姐妹",
  "神的时代 : 雷霆4神": "神的时代 : 雷霆4神",
  "神的时代 : 奥林匹斯之国王": "神的时代 : 奥林匹斯之国王",
  "狂野亚马逊": "狂野亚马逊",
  "弓兵": "弓兵",
  "亚特兰蒂斯女王": "亚特兰蒂斯女王",
  "海滨嘉年华": "海滨嘉年华",
  "百慕大三角": "百慕大三角",
  "奖金熊": "奖金熊",
  "杰克与魔豆": "杰克与魔豆",
  "野牛闪电战": "野牛闪电战",
  "船长的宝藏": "船长的宝藏",
  "拉斯维加斯的猫": "拉斯维加斯的猫",
  "猫女王": "猫女王",
  "超级888": "超级888",
  "樱桃之恋": "樱桃之恋",
  "美女船长": "美女船长",
  "中国厨房": "中国厨房",
  "牛仔和外星人": "牛仔和外星人",
  "疯狂之七": "疯狂之七",
  "大胆的戴夫和荷鲁斯之眼": "大胆的戴夫和荷鲁斯之眼",
  "沙漠宝藏": "沙漠宝藏",
  "海豚礁": "海豚礁",
  "惊喜复活节": "惊喜复活节",
  "翡翠公主": "翡翠公主",
  "疯狂麻将": "疯狂麻将",
  "五虎将": "五虎将",
  "足球狂欢节": "足球狂欢节",
  "终极足球": "终极足球",
  "惊异之林": "惊异之林",
  "幸运5": "幸运5",
  "青春之泉": "青春之泉",
  "戴图理的神奇七": "戴图理的神奇七",
  "戴图理的神奇七大奖": "戴图理的神奇七大奖",
  "水果狂": "水果狂",
  "幸运月": "幸运月",
  "酷炫水果农场": "酷炫水果农场",
  "趣味水果大奖": "趣味水果大奖",
  "古怪猴子": "古怪猴子",
  "艺伎故事": "艺伎故事",
  "宝石女王": "宝石女王",
  "角斗士彩池游戏": "角斗士彩池游戏",
  "黄金之旅": "黄金之旅",
  "湛蓝深海": "湛蓝深海",
  "万圣节财富": "万圣节财富",
  "万圣节财富2": "万圣节财富2",
  "鬼屋": "鬼屋",
  "丛林心脏": "丛林心脏",
  "武则天": "武则天",
  "高速公路之王": "高速公路之王",
  "热力宝石": "热力宝石",
  "浮冰流": "浮冰流",
  "火热KTV": "火热KTV",
  "印加帝国头奖": "印加帝国头奖",
  "奖金巨人": "奖金巨人",
  "吉祥8": "吉祥8",
  "金钱蛙": "金钱蛙",
  "金土地": "金土地",
  "烈焰钻石": "烈焰钻石",
  "六福兽": "六福兽",
  "真人7座百家乐": "真人7座百家乐",
  "实况法式轮盘赌": "实况法式轮盘赌",
  "疯狂乐透": "疯狂乐透",
  "神奇的栈": "神奇的栈",
  "玛丽莲梦露": "玛丽莲梦露",
  "迷你百家乐": "迷你百家乐",
  "Cash back先生": "Cash back先生",
  "海王星王国": "海王星王国",
  "年年有余": "年年有余",
  "无抽水真人迷你百家乐": "无抽水真人迷你百家乐",
  "黑豹之月": "黑豹之月",
  "企鹅假期": "企鹅假期",
  "法老王的秘密": "法老王的秘密",
  "小猪与狼": "小猪与狼",
  "粉红豹": "粉红豹",
  "非常幸运": "非常幸运",
  "热紫": "热紫",
  "权杖女王": "权杖女王",
  "日日进财": "日日进财",
  "日日生財": "日日生财",
  "洛基传奇": "洛基传奇",
  "真人轮盘赌": "真人轮盘赌",
  "热带动物园": "热带动物园",
  "巴西森宝": "巴西森宝",
  "圣诞奇迹": "圣诞奇迹",
  "亚马逊的秘密": "亚马逊的秘密",
  "夏洛克的秘密": "夏洛克的秘密",
  "四象": "四象",
  "沉默的武士": "沉默的武士",
  "银弹": "银弹",
  "辛巴达的黄金之旅": "辛巴达的黄金之旅",
  "黄金农场": "黄金农场",
  "好运连胜": "好运连胜",
  "甜蜜派对": "甜蜜派对",
  "泰国天堂": "泰国天堂",
  "大明帝国": "大明帝国",
  "堂吉诃德的财富": "堂吉诃德的财富",
  "三剑客和女王": "三剑客和女王",
  "壮志凌云": "壮志凌云",
  "三倍猴子": "三倍猴子",
  "开心假期": "开心假期",
  "豪华的开心假期": "豪华的开心假期",
  "疯狂维京海盗": "疯狂维京海盗",
  "白狮王": "白狮王",
  "赌徒": "赌徒",
  "疯狂赌徒2 : 北极探险": "疯狂赌徒2 : 北极探险",
  "我心狂野": "我心狂野",
  "黄金翅膀": "黄金翅膀",
  "五路财神": "五路财神",
  "招财进宝彩池游戏": "招财进宝彩池游戏",
  "招财童子": "招财童子",
  "野外宝藏": "野外宝藏",
  "冰穴": "冰穴",
  "边境之心": "边境之心",
  "古怪猴子彩池": "古怪猴子彩池",
  "湛蓝深海彩池TM": "湛蓝深海彩池TM",
  "云从龙": "云从龙",
  "玄圃联欢": "玄圃联欢",
  "幸运盖尔": "幸运盖尔",
  "武士元素": "武士元素",
  "超级法老王宝藏": "超级法老王宝藏",
  "丛林巨兽": "丛林巨兽",
  "猿人传奇": "猿人传奇",
  "龙之战士": "龙之战士",
  "旋转与胜利": "旋转与胜利",
  "记忆盛宴": "记忆盛宴",
  "隐秘境界的突袭": "隐秘境界的突袭",
  "相扑君的逆袭": "相扑君的逆袭",
  "英雄吕布": "英雄吕布",
  "龙的财富": "龙的财富",
  "凤凰之道": "凤凰之道",
  "币币币": "币币币",
  "虎爪": "虎爪",
  "狂野蟒蛇": "狂野蟒蛇",
  "发财黑豹": "发财黑豹",
  "嫦娥奔月": "嫦娥奔月",
  "金福幸运": "金福幸运",
  "天之女王": "天之女王",
  "青龙,白虎,朱雀,玄武": "青龙,白虎,朱雀,玄武",
  "发财 财神": "发财 财神",
  "金钱蛙头奖": "金钱蛙头奖",
  "狂热重舞狮将池": "狂热重舞狮将池",
  "招财童子头奖": "招财童子头奖",
  "真人赌场扑克": "真人赌场扑克",
  "量子轮盘赌": "量子轮盘赌",
  "龙门传说": "龙门传说",
  "金福龙": "金福龙",
  "法老王的女儿": "法老王的女儿",
  "野蛮丛林": "野蛮丛林",
  "龙驾祥云": "龙驾祥云",
  "阿兹特克送福": "阿兹特克送福",
  "五行火送福": "五行火送福",
  "五行金送福": "五行金送福",
  "河船送福": "河船送福",
  "五行水送福": "五行水送福",
  "蓝精灵": "蓝精灵",
  "财神兴盛": "财神兴盛",
  "老虎堆": "老虎堆",
  "你属什么": "你属什么",
  "白色王者2": "白色王者2",
  "疯狂猴子": "疯狂猴子",
  "发财熊猫": "发财熊猫",
  "恐怖嘉年华": "恐怖嘉年华",
  "中国新年": "中国新年",
  "功夫传奇": "功夫传奇",
  "包租婆": "包租婆",
  "王牌狂徒": "王牌狂徒",
  "巨龙宝藏": "巨龙宝藏",
  "摔跤英雄": "摔跤英雄",
  "胡桃夹子": "胡桃夹子",
  "神庙丽影": "神庙丽影",
  "赌城之夜": "赌城之夜",
  "极品飙车": "极品飙车",
  "寿司大食客": "寿司大食客",
  "皇家戏台": "皇家戏台",
  "蒸汽战争": "蒸汽战争",
  "魅惑魔女": "魅惑魔女",
  "横行霸道": "横行霸道",
  "古惑仔": "古惑仔",
  "神奇宠物": "神奇宠物",
  "魔龙": "魔龙",
  "埃及宝藏": "埃及宝藏",
  "和风剧院": "和风剧院",
  "封神演义": "封神演义",
  "五狮进宝": "五狮进宝",
  "圣女贞德": "圣女贞德",
  "招财锦鲤": "招财锦鲤",
  "十二生肖": "十二生肖",
  "葫芦兄弟": "葫芦兄弟",
  "贪玩蓝月": "贪玩蓝月",
  "内衣橄榄球": "内衣橄榄球",
  "白雪公主": "白雪公主",
  "多宝鱼虾蟹": "多宝鱼虾蟹",
  "跳跳乐": "跳跳乐",
  "僵尸来袭": "僵尸来袭",
  "永恒之吻": "永恒之吻",
  "狂野女巫": "狂野女巫",
  "百搭777": "百搭777",
  "钻石女王": "钻石女王",
  "爱丽丝大冒险": "爱丽丝大冒险",
  "战火风云": "战火风云",
  "亚瑟王": "亚瑟王",
  "穆夏女神": "穆夏女神",
  "龙虎": "龙虎",
  "冠军足球": "冠军足球",
  "王者传说": "王者传说",
  "骰宝": "骰宝",
  "阿里巴巴": "阿里巴巴",
  "神奇宝石": "神奇宝石",
  "XIN哥来了": "XIN哥来了",
  "金龙珠": "金龙珠",
  "猛龙传奇": "猛龙传奇",
  "金拉霸": "金拉霸",
  "街头烈战": "街头烈战",
  "美女大格斗": "美女大格斗",
  "中秋佳节": "中秋佳节",
  "韩风劲舞": "韩风劲舞",
  "黄金对垒": "黄金对垒",
  "龙舟竞渡": "龙舟竞渡",
  "冰河世界": "冰河世界",
  "糖果碰碰乐": "糖果碰碰乐",
  "水果拉霸2": "水果拉霸2",
  "上海百乐门": "上海百乐门",
  "龙珠": "龙珠",
  "幸运8": "幸运8",
  "闪亮女郎": "闪亮女郎",
  "金鱼": "金鱼",
  "海盗王": "海盗王",
  "鲜果狂热": "鲜果狂热",
  "小熊猫": "小熊猫",
  "大豪客": "大豪客",
  "灵猴献瑞": "灵猴献瑞",
  "武财神": "武财神",
  "象棋老虎机": "象棋老虎机",
  "开心农场": "开心农场",
  "麻将老虎机": "麻将老虎机",
  "夏日营地": "夏日营地",
  "太空漫游": "太空漫游",
  "日本武士": "日本武士",
  "复古花园": "复古花园",
  "杰克高手(大版视频扑克)": "杰克高手(大版视频扑克)",
  "疯狂德州": "疯狂德州",
  "皇牌ACE": "皇牌ACE",
  "奔驰宝马": "奔驰宝马",
  "極速赛马": "极速赛马",
  "猜猜乐": "猜猜乐",
  "德州牛仔": "德州牛仔",
  "森林舞会多人版": "森林舞会多人版",
  "水果拉霸多人版": "水果拉霸多人版",
  "百人牛牛": "百人牛牛",
  "多宝水果拉霸": "多宝水果拉霸",
  "彩金水果拉霸": "彩金水果拉霸",
  "飞禽走兽多人版": "飞禽走兽多人版",
  "牛牛对战": "牛牛对战",
  "奔驰宝马多人版": "奔驰宝马多人版",
  "动物狂欢": "动物狂欢",
  "西游争霸": "西游争霸",
  "翻倍炸金花": "翻倍炸金花",
  "刺激战场": "刺激战场",
  "斗三公": "斗三公",
  "红黑梅方": "红黑梅方",
  "彩金宝藏世界": "彩金宝藏世界",
  "彩金奔驰宝马": "彩金奔驰宝马",
  "海陆争霸": "海陆争霸",
  "百人推筒子": "百人推筒子",
  "功夫万条筒": "功夫万条筒",
  "双喜炸金花": "双喜炸金花",
  "凤凰传奇": "凤凰传奇",
  "全民21点": "全民21点",
  "福星推筒子": "福星推筒子",
  "YP刮刮卡": "YP刮刮卡",
  "财富转盘": "财富转盘",
  "射龙门": "射龙门",
  "11选5": "11选5",
  "幸运7": "幸运7",
  "宠物乐园": "宠物乐园",
  "彩金飞禽走兽": "彩金飞禽走兽",
  "彩金森林舞会": "彩金森林舞会",
  "三星报喜": "三星报喜",
  "法力无边": "法力无边",
  "曲棍球联盟": "曲棍球联盟",
  "奥林匹斯之门": "奥林匹斯之门",
  "富矿宝石": "富矿宝石",
  "行尸走肉": "行尸走肉",
  "崛起的武士": "崛起的武士",
  "五狮团拜": "五狮团拜",
  "星际赏金": "星际赏金",
  "巨大犀牛加强版": "巨大犀牛加强版",
  "爱尔兰人宝藏": "爱尔兰人宝藏",
  "超级持控旋转": "超级持控旋转",
  "狼人的诅咒": "狼人的诅咒",
  "深林之猩": "深林之猩",
  "古时代宝石加强版": "古时代宝石加强版",
  "汪汪之家Megaways": "汪汪之家Megaways",
  "武松打虎": "武松打虎",
  "街头赛车": "街头赛车",
  "福福福": "福福福",
  "群龙保珠-宝石致富": "群龙保珠-宝石致富",
  "布洛克精神": "布洛克精神",
  "王者金字塔": "王者金字塔",
  "超级燃烧": "超级燃烧",
  "钱生钱": "钱生钱",
  "行星宝石Megaways": "行星宝石Megaways",
  "约翰·亨特之埃及图特书": "约翰·亨特之埃及图特书",
  "巨大犀牛Megaways": "巨大犀牛Megaways",
  "热火燃烧": "热火燃烧",
  "跳舞趴": "跳舞趴",
  "西部牛仔黄金地段": "西部牛仔黄金地段",
  "金龙吐珠": "金龙吐珠",
  "彩虹水果": "彩虹水果",
  "疯狂机器": "疯狂机器",
  "阿兹特克获利之道": "阿兹特克获利之道",
  "神秘之城": "神秘之城",
  "贵妃美人": "贵妃美人",
  "杰克大师": "杰克大师",
  "超级7s": "超级7s",
  "解放大海怪": "解放大海怪",
  "王者野牛": "王者野牛",
  "招财鼠": "招财鼠",
  "阿拉丁和巫师": "阿拉丁和巫师",
  "希腊众神": "希腊众神",
  "甜心盛宴圣诞": "甜心盛宴圣诞",
  "大力神和飞马": "大力神和飞马",
  "红火暴击": "红火暴击",
  "超炫小丑": "超炫小丑",
  "金龟子女王": "金龟子女王",
  "发发树": "发发树",
  "小鸡大逃亡": "小鸡大逃亡",
  "吸血鬼vs狼": "吸血鬼vs狼",
  "超级辣": "超级辣",
  "阿兹特克秘宝": "阿兹特克秘宝",
  "酷猴战士": "酷猴战士",
  "龙虎斗": "龙虎斗",
  "3倍小丑": "3倍小丑",
  "5金狮": "5金狮",
  "野精灵": "野精灵",
  "甜入心扉": "甜入心扉",
  "财神运财": "财神运财",
  "夺金海贼": "夺金海贼",
  "汪汪之家": "汪汪之家",
  "埃及宿命": "埃及宿命",
  "额外多汁": "额外多汁",
  "龙宝百家乐": "龙宝百家乐",
  "狂野角斗士": "狂野角斗士",
  "招财福猪": "招财福猪",
  "狩猎之王": "狩猎之王",
  "小妖之歌圣诞版": "小妖之歌圣诞版",
  "黄金野马": "黄金野马",
  "百家乐": "百家乐",
  "古代埃及经典版": "古代埃及经典版",
  "魔力维加斯": "魔力维加斯",
  "陈师傅的财富": "陈师傅的财富",
  "达芬奇宝藏": "达芬奇宝藏",
  "好运北京": "好运北京",
  "小妖之歌": "小妖之歌",
  "玉蝴蝶": "玉蝴蝶",
  "命运女士": "命运女士",
  "仙宫": "仙宫",
  "5雄狮": "5雄狮",
  "冠军杯": "冠军杯",
  "巨大犀牛": "巨大犀牛",
  "小丑珠宝": "小丑珠宝",
  "童话财富": "童话财富",
  "88火": "88火",
  "火辣辣": "火辣辣",
  "美式二十一点": "美式二十一点",
  "古时代宝石": "古时代宝石",
  "古代埃及": "古代埃及",
  "幸运新年": "幸运新年",
  "三只老虎": "三只老虎",
  "猴子疯狂": "猴子疯狂",
  "淘金热": "淘金热",
  "圣诞老人": "圣诞老人",
  "熊猫财富": "熊猫财富",
  "财源滚滚": "财源滚滚",
  "7只小猪": "7只小猪",
  "钻石罢工": "钻石罢工",
  "维加斯之夜": "维加斯之夜",
  "财神黄金": "财神黄金",
  "精灵翅膀": "精灵翅膀",
  "黄金列车": "黄金列车",
  "发发发龙": "发发发龙",
  "侏罗纪巨兽": "侏罗纪巨兽",
  "8条龙": "8条龙",
  "野狼黄金": "野狼黄金",
  "黑豹女王": "黑豹女王",
  "爱尔兰的魅力": "爱尔兰的魅力",
  "黄金女王": "黄金女王",
  "富贵888": "富贵888",
  "21点之富贵临门": "21点之富贵临门",
  "永恒钻石3线": "永恒钻石3线",
  "龙之国度": "龙之国度",
  "宙斯之子赫拉克勒斯": "宙斯之子赫拉克勒斯",
  "3个精灵愿望": "3个精灵愿望",
  "猫爸第二部分": "猫爸第二部分",
  "西游记": "西游记",
  "贝奥武夫": "贝奥武夫",
  "狂野冰球赛": "狂野冰球赛",
  "矮人黄金豪华版": "矮人黄金豪华版",
  "罗密欧与朱丽叶": "罗密欧与朱丽叶",
  "野生动物园": "野生动物园",
  "猫咪派对": "猫咪派对",
  "无敌金刚": "无敌金刚",
  "女神戈帝梵": "女神戈帝梵",
  "歌厅": "歌厅",
  "魔幻水晶": "魔幻水晶",
  "阿拉丁宝藏": "阿拉丁宝藏",
  "月之女神": "月之女神",
  "埃及传说": "埃及传说",
  "极速糖果": "极速糖果",
  "极速糖果冬日版": "极速糖果冬日版",
  "极速糖果情人版": "极速糖果情人版",
  "极速糖果夏日版": "极速糖果夏日版",
  "幽灵财富": "幽灵财富",
  "轮盘": "轮盘",
  "基诺": "基诺",
  "杰克扑克": "杰克扑克",
  "大堡礁": "大堡礁",
  "荣耀罗马": "荣耀罗马",
  "水果爆破": "水果爆破",
  "矮人黄金": "矮人黄金",
  "恶魔13": "恶魔13",
  "疯狂7s": "疯狂7s",
  "勤劳蜜蜂": "勤劳蜜蜂",
  "7只猴子": "7只猴子",
  "金猪报财": "金猪报财",
  "寻龙探宝": "寻龙探宝",
  "十倍金牛": "十倍金牛",
  "夜戏貂蝉": "夜戏貂蝉",
  "横财来啦": "横财来啦",
  "美杜莎II": "美杜莎II",
  "摇钱树": "摇钱树",
  "美杜莎": "美杜莎",
  "欧式二十一点": "欧式二十一点",
  "抓抓乐": "抓抓乐",
  "巫师之书": "巫师之书",
  "宝石侠": "宝石侠",
  "蒸汽朋克:命运的旋转": "蒸汽朋克:命运的旋转",
  "国王的召唤": "国王的召唤",
  "逆袭的小红帽": "逆袭的小红帽",
  "麻辣火锅": "麻辣火锅",
  "万胜狂欢夜": "万胜狂欢夜",
  "后羿射日": "后羿射日",
  "舞狮进宝": "舞狮进宝",
  "嘻哈熊猫": "嘻哈熊猫",
  "圣诞欢乐送": "圣诞欢乐送",
  "至尊百家乐": "至尊百家乐",
  "宝石侠-大宝剑": "宝石侠-大宝剑",
  "埃及寻宝": "埃及寻宝",
  "皇上吉祥": "皇上吉祥",
  "象财神": "象财神",
  "三只猴子": "三只猴子",
  "水果丛林": "水果丛林",
  "双囍临门": "双囍临门",
  "冰雪大冲关": "冰雪大冲关",
  "嘻游记": "嘻游记",
  "赏金船长": "赏金船长",
  "爱尔兰精灵": "爱尔兰精灵",
  "忍者vs武侍": "忍者vs武侍",
  "龙虎争霸": "龙虎争霸",
  "麻将胡了": "麻将胡了",
  "鼠鼠福福": "鼠鼠福福",
  "亲爱的": "亲爱的",
  "宝石侠-宝藏征途": "宝石侠-宝藏征途",
  "少林足球": "少林足球",
  "赢财神": "赢财神",
  "糖果连连爆": "糖果连连爆",
  "比基尼天堂": "比基尼天堂",
  "麻将胡了2": "麻将胡了2",
  "埃及探秘宝典": "埃及探秘宝典",
  "福运象财神": "福运象财神",
  "高低扑克": "高低扑克",
  "澳门壕梦": "澳门壕梦",
  "高低五福": "高低五福",
  "高低骰宝": "高低骰宝",
  "火树赢花": "火树赢花",
  "添好运": "添好运",
  "阿拉丁神灯": "阿拉丁神灯",
  "寻宝黄金城": "寻宝黄金城",
  "欢乐嘉年华": "欢乐嘉年华",
  "水上泰神奇": "水上泰神奇",
  "艳后之谜": "艳后之谜",
  "德古拉女爵": "德古拉女爵",
  "赏金女王": "赏金女王",
  "招财喵": "招财喵",
  "冰锋奇侠": "冰锋奇侠",
  "星旅淘金": "星旅淘金",
  "冰火双娇": "冰火双娇",
  "新国粹": "新国粹",
  "巴厘之旅": "巴厘之旅",
  "比特淘金": "比特淘金",
  "亡灵大盗": "亡灵大盗",
  "麒麟送宝": "麒麟送宝",
  "美杜莎 II": "美杜莎 II",
  "宝石侠 - 宝藏征途": "宝石侠 - 宝藏征途",
  "糖心风暴": "糖心风暴",
  "霹雳神偷": "霹雳神偷",
  "太阳神传说": "太阳神传说",
  "寿司之道": "寿司之道",
  "恐龙帝国": "恐龙帝国",
  "人鱼公主": "人鱼公主",
  "地鼠总动员": "地鼠总动员",
  "丽影奇兵之探秘埃及": "丽影奇兵之探秘埃及",
  "超市大血拼": "超市大血拼",
  "美洲野牛": "美洲野牛",
  "美猴王传奇": "美猴王传奇",
  "百鬼夜行": "百鬼夜行",
  "星际农场": "星际农场",
  "钞级表情包": "钞级表情包",
  "夜醉佳人": "夜醉佳人",
  "江山美景图": "江山美景图",
  "虎虎生财": "虎虎生财",
  "神鹰宝石": "神鹰宝石",
  "日月星辰": "日月星辰",
  "蝶恋花": "蝶恋花",
  "韩宫御宴": "韩宫御宴",
  "绝地大逃杀": "绝地大逃杀",
  "发财鱼虾蟹": "发财鱼虾蟹",
  "电玩金猪": "电玩金猪",
  "极速赢家": "极速赢家",
  "珀尔修斯传奇": "珀尔修斯传奇",
  "疯赚过山车": "疯赚过山车",
  "赏金大对决": "赏金大对决",
  "黄金摇钱树": "黄金摇钱树",
  "图腾奇迹": "图腾奇迹",
  "炼金工坊": "炼金工坊",
  "非洲历险": "非洲历险",
  "不朽荣耀": "不朽荣耀",
  "矮胖麦克杜": "矮胖麦克杜",
  "6枚黄金代币": "6枚黄金代币",
  "11勇士": "11勇士",
  "3小神": "3小神",
  "阿里娅的愿望": "阿里娅的愿望",
  "全胜足球俱乐部": "全胜足球俱乐部",
  "伟大阿兹特克": "伟大阿兹特克",
  "远古勇士": "远古勇士",
  "尼人": "尼人",
  "深海宝藏": "深海宝藏",
  "黄金竞技场": "黄金竞技场",
  "亚瑟王黄金": "亚瑟王黄金",
  "进击复古城": "进击复古城",
  "欧若拉野兽猎人": "欧若拉野兽猎人",
  "阿特曼之书": "阿特曼之书",
  "钻石之力™": "钻石之力™",
  "钻石烈焰": "钻石烈焰",
  "电光大道": "电光大道",
  "堡垒冲锋": "堡垒冲锋",
  "象牙塔": "象牙塔",
  "大地女神": "大地女神",
  "锁定好运": "锁定好运",
  "威武巨龙": "威武巨龙",
  "玛雅之鹰": "玛雅之鹰",
  "迈阿密光芒": "迈阿密光芒",
  "挖矿狂热": "挖矿狂热",
  "高贵老鼠": "高贵老鼠",
  "北方风暴": "北方风暴",
  "复古星系": "复古星系",
  "皇室崛起": "皇室崛起",
  "罗马力量": "罗马力量",
  "七7™": "七7™",
  "星际传送门": "星际传送门",
  "赏金": "赏金",
  "金库神偷": "金库神偷",
  "疯狂提基": "疯狂提基",
  "宝藏英雄": "宝藏英雄",
  "宝藏天空": "宝藏天空",
  "狼嚎": "狼嚎",
  "惊奇森林": "惊奇森林",
  "甜水绿洲": "甜水绿洲",
  "女校啦啦队": "女校啦啦队",
  "抢红包2": "抢红包2",
  "变形金刚": "变形金刚",
  "摸金校尉": "摸金校尉",
  "66路": "66路",
  "阿兹特克": "阿兹特克",
  "埃及": "埃及",
  "狂欢": "狂欢",
  "中世纪特权": "中世纪特权",
  "大秦帝国": "大秦帝国",
  "火影忍者": "火影忍者",
  "欢乐水果": "欢乐水果",
  "战舰少女": "战舰少女",
  "东方国度": "东方国度",
  "西部牛仔": "西部牛仔",
  "幻想大陆": "幻想大陆",
  "拉斯维加斯": "拉斯维加斯",
  "荒野大镖客": "荒野大镖客",
  "埃及艳后": "埃及艳后",
  "仙剑": "仙剑",
  "80天旅行": "80天旅行",
  "海盗财富": "海盗财富",
  "西游": "西游",
  "指环王": "指环王",
  "荣耀王者": "荣耀王者",
  "怪物命运": "怪物命运",
  "埃菲尔": "埃菲尔",
  "新年符号": "新年符号",
  "性感女神": "性感女神",
  "世界末日": "世界末日",
  "现代战争": "现代战争",
  "加勒比海盗": "加勒比海盗",
  "功夫熊猫": "功夫熊猫",
  "侏罗纪": "侏罗纪",
  "植物大战僵尸": "植物大战僵尸",
  "守望英雄": "守望英雄",
  "阿凡达": "阿凡达",
  "希腊传说": "希腊传说",
  "吸血鬼PK狼人": "吸血鬼PK狼人",
  "梦幻西游": "梦幻西游",
  "女校足球队": "女校足球队",
  "女校橄榄球": "女校橄榄球",
  "女校剑道部": "女校剑道部",
  "武圣关云长": "武圣关云长",
  "刺客信条": "刺客信条",
  "古墓丽影": "古墓丽影",
  "绿野仙踪": "绿野仙踪",
  "剑侠情缘": "剑侠情缘",
  "格斗之王": "格斗之王",
  "黑珍珠号": "黑珍珠号",
  "富饶农场": "富饶农场",
  "玛雅": "玛雅",
  "印第安": "印第安",
  "神秘东方": "神秘东方",
  "战争": "战争",
  "哪吒闹海": "哪吒闹海",
  "七夕情缘": "七夕情缘",
  "四大美女": "四大美女",
  "红楼梦": "红楼梦",
  "女校游泳队": "女校游泳队",
  "女校体操队": "女校体操队",
  "天龙八部": "天龙八部",
  "鹿鼎记": "鹿鼎记",
  "笑傲江湖": "笑傲江湖",
  "神雕侠侣": "神雕侠侣",
  "幸运水果机": "幸运水果机",
  "钻石之恋": "钻石之恋",
  "众神之王": "众神之王",
  "粉红女郎": "粉红女郎",
  "鸟叔": "鸟叔",
  "十二星座": "十二星座",
  "愤怒的小鸟": "愤怒的小鸟",
  "捕鱼达人": "捕鱼达人",
  "瑞狗迎春": "瑞狗迎春",
  "哥谭魅影猫女": "哥谭魅影猫女",
  "金狗旺财": "金狗旺财",
  "恭贺新春": "恭贺新春",
  "角斗士": "角斗士",
  "埃及女王": "埃及女王",
  "灌篮高手": "灌篮高手",
  "抢红包": "抢红包",
  "闹元宵": "闹元宵",
  "金球争霸": "金球争霸",
  "黄金右脚": "黄金右脚",
  "世界杯吉祥物": "世界杯吉祥物",
  "潘帕斯雄鹰": "潘帕斯雄鹰",
  "群星闪耀": "群星闪耀",
  "金靴争霸": "金靴争霸",
  "激情球迷": "激情球迷",
  "激情世界杯": "激情世界杯",
  "人猿泰山": "人猿泰山",
  "船长宝藏": "船长宝藏",
  "疯狂七": "疯狂七",
  "鹊桥会": "鹊桥会",
  "泰坦尼克号": "泰坦尼克号",
  "蜘蛛侠": "蜘蛛侠",
  "速度与激情": "速度与激情",
  "海岛奇兵": "海岛奇兵",
  "百变猴子": "百变猴子",
  "新年": "新年",
  "街机水浒传": "街机水浒传",
  "水浒英雄": "水浒英雄",
  "水果机": "水果机",
  "黄金大转轮": "黄金大转轮",
  "水果转盘": "水果转盘",
  "赛马": "赛马",
  "浮岛历险记": "浮岛历险记",
  "水果传奇": "水果传奇",
  "萌宠夺宝": "萌宠夺宝",
  "龙珠探宝": "龙珠探宝",
  "奔驰宝马2": "奔驰宝马2",
  "纸牌老虎机": "纸牌老虎机",
  "军师": "军师",
  "五龙争霸MegaBonus": "五龙争霸MegaBonus",
  "水果777": "水果777",
  "拳皇": "拳皇",
  "乐高大电影": "乐高大电影",
  "水果小玛丽": "水果小玛丽",
  "福临门": "福临门",
  "点球大战": "点球大战",
  "水浒传": "水浒传",
  "淘金者": "淘金者",
  "五龙争霸": "五龙争霸",
  "楚河汉界": "楚河汉界",
  "万圣节": "万圣节",
  "缤纷果园": "缤纷果园",
  "鬼新娘": "鬼新娘",
  "皇城年夜": "皇城年夜",
  "路飞传奇2": "路飞传奇2",
  "夏日海滩": "夏日海滩",
  "武松传2": "武松传2",
  "烈焰女王": "烈焰女王",
  "英灵殿": "英灵殿",
  "欢乐圣诞": "欢乐圣诞",
  "财富丛林": "财富丛林",
  "夏洛克": "夏洛克",
  "猫剑客": "猫剑客",
  "动物森林": "动物森林",
  "约会之夜": "约会之夜",
  "忍者物语": "忍者物语",
  "寻找彩蛋": "寻找彩蛋",
  "捕鱼消消乐": "捕鱼消消乐",
  "大三元": "大三元",
  "魔术嘉年华": "魔术嘉年华",
  "楚河汉界MegaBonus": "楚河汉界MegaBonus",
  "缤纷果园MegaBonus": "缤纷果园MegaBonus",
  "约会之夜MegaBonus": "约会之夜MegaBonus",
  "财神到3": "财神到3",
  "十二生肖3": "十二生肖3",
  "福临门3": "福临门3",
  "点球大战3": "点球大战3",
  "皇城年夜3": "皇城年夜3",
  "龙龙龙2": "龙龙龙2",
  "太空冒险": "太空冒险",
  "三倍狐猴": "三倍狐猴",
  "麻将发发发": "麻将发发发",
  "幸运双连": "幸运双连",
  "排球巨星": "排球巨星",
  "宝石矿坑": "宝石矿坑",
  "讨虎传": "讨虎传",
  "聂小倩": "聂小倩",
  "月亮派对": "月亮派对",
  "鱼多多": "鱼多多",
  "麻将发了": "麻将发了",
  "动物好朋友": "动物好朋友",
  "开运舞狮7": "开运舞狮7",
  "鱼跃龙门7": "鱼跃龙门7",
  "5X钻石7": "5X钻石7",
  "爆金闪电7": "爆金闪电7",
  "爆金火焰7": "爆金火焰7",
  "爆金彩虹7": "爆金彩虹7",
  "祥龙戏珠7": "祥龙戏珠7",
  "福多多7": "福多多7",
  "爆金777": "爆金777",
  "千岁凤": "千岁凤",
  "幸运四叶草": "幸运四叶草",
  "比基尼狂热": "比基尼狂热",
  "御火圣兽": "御火圣兽",
  "糖果女王": "糖果女王",
  "龙后魅影": "龙后魅影",
  "超能战姬": "超能战姬",
  "泰象": "泰象",
  "蜀国英杰": "蜀国英杰",
  "三剑客": "三剑客",
  "炸弹神偷": "炸弹神偷",
  "奇幻神灯": "奇幻神灯",
  "打擂台": "打擂台",
  "屠龙英雄": "屠龙英雄",
  "埃及夺金": "埃及夺金",
  "斯巴达之尊": "斯巴达之尊",
  "三星报囍2": "三星报囍2",
  "六脉传奇": "六脉传奇",
  "马雅秘宝": "马雅秘宝",
  "猪八戒": "猪八戒",
  "假面王子": "假面王子",
  "上海教父": "上海教父",
  "双囍": "双囍",
  "世界杯狂热": "世界杯狂热",
  "龙8": "龙8",
  "运财童子": "运财童子",
  "鸿运金狮": "鸿运金狮",
  "幸运发": "幸运发",
  "富贵7": "富贵7",
  "招财猫": "招财猫",
  "将圣": "将圣",
  "红楼春梦": "红楼春梦",
  "美女沙排": "美女沙排",
  "丧尸猎人": "丧尸猎人",
  "张保仔": "张保仔",
  "魔鬼天使": "魔鬼天使",
  "运财金鸡": "运财金鸡",
  "济公": "济公",
  "锦衣卫": "锦衣卫",
  "脆爆水果": "脆爆水果",
  "幸运金钻": "幸运金钻",
  "热带宝藏": "热带宝藏",
  "南北狮王": "南北狮王",
  "赤龙": "赤龙",
  "欢乐农场": "欢乐农场",
  "同校生": "同校生",
  "梦幻女神": "梦幻女神",
  "趣怪丧尸": "趣怪丧尸",
  "三星报囍": "三星报囍",
  "过大年": "过大年",
  "瘋狂錢來也": "疯狂钱来也",
  "無限王牌": "无限王牌",
  "幸運女神": "幸运女神",
  "寶石派對": "宝石派对",
  "火熱辣椒": "火热辣椒",
  "秦皇傳說": "秦皇传说",
  "舞龍爭霸": "舞龙争霸",
  "發財樹": "发财树",
  "上海甜心": "上海甜心",
  "極速發發發": "极速发发发",
  "關雲長": "关云长",
  "極速777": "极速777",
  "瘋狂777": "疯狂777",
  "人魚甜心": "人鱼甜心",
  "包青天": "包青天",
  "瘋狂一路發": "疯狂一路发",
  "喜洋洋": "喜洋洋",
  "極速豬來了": "极速猪来了",
  "糖果寶貝": "糖果宝贝",
  "封神": "封神",
  "瘋狂搶金樂": "疯狂抢金乐",
  "霸金磚": "霸金砖",
  "神龍奪寶": "神龙夺宝",
  "衝鋒野牛": "冲锋野牛",
  "超級王牌": "超级王牌",
  "黃金艷后": "黄金艳后",
  "叢林之王": "丛林之王",
  "拳王": "拳王",
  "秘境奪寶": "秘境夺宝",
  "法老祕寶": "法老秘宝",
  "象財神": "象财神",
  "真有錢": "真有钱",
  "羅馬X": "罗马X",
  "黃金帝國": "黄金帝国",
  "迦羅寶石": "迦罗宝石",
  "瘋狂砲手": "疯狂炮手",
  "嗨翻夜": "嗨翻夜",
  "阿拉丁": "阿拉丁",
  "王牌特務": "王牌特务",
  "TWINWINS": "TWINWINS",
  "梅杜莎": "梅杜莎",
  "黃金之書": "黄金之书",
  "龍虎競猜": "龙虎竞猜",
  "骰子競猜": "骰子竞猜",
  "七上下競猜": "七上下竞猜",
  "數字競猜": "数字竞猜",
  "爆炸糖2": "爆炸糖2",
  "一本萬利": "一本万利",
  "猴寶寶": "猴宝宝",
  "猴寶寶2": "猴宝宝2",
  "爆炸糖": "爆炸糖",
  "發發發": "发发发",
  "運財童子": "运财童子",
  "魔鑽": "魔钻",
  "超級巨星": "超级巨星",
  "搖錢樹": "摇钱树",
  "聯盟": "联盟",
  "幸運骰": "幸运骰",
  "招財8": "招财8",
  "大熊貓": "大熊猫",
  "龍8": "龙8",
  "龍珠": "龙珠",
  "聯盟 2": "联盟 2",
  "銀河瘋爆": "银河疯爆",
  "一路發": "一路发",
  "外星人": "外星人",
  "海洋世界": "海洋世界",
  "環遊世界": "环游世界",
  "麻將": "麻将",
  "魔法球": "魔法球",
  "船長的寶藏": "船长的宝藏",
  "招財進寶": "招财进宝",
  "豐財聚寶": "丰财聚宝",
  "吉祥如意": "吉祥如意",
  "金獅賀歲": "金狮贺岁",
  "魔鑽 2": "魔钻 2",
  "年年有餘": "年年有余",
  "糖果瘋爆": "糖果疯爆",
  "冰上曲棍球": "冰上曲棍球",
  "古怪猴子5000倍": "古怪猴子5000倍",
  "如意棒": "如意棒",
  "功夫猴子": "功夫猴子",
  "泰國之美": "泰国之美",
  "龍王": "龙王",
  "招財神獸": "招财神兽",
  "中國錦鯉": "中国锦鲤",
  "印度之宝": "印度之宝",
  "祖玛传奇": "祖玛传奇",
  "武媚娘": "武媚娘",
  "罗马帝国": "罗马帝国",
  "五虎": "五虎",
  "古埃及": "古埃及",
  "海豚": "海豚",
  "凯洛琳夫人": "凯洛琳夫人",
  "疯猴子岛": "疯猴子岛",
  "宝盒": "宝盒",
  "幸运熊猫": "幸运熊猫",
  "牛逼特工": "牛逼特工",
  "恭喜发财": "恭喜发财",
  "猴子": "猴子",
  "天子": "天子",
  "机械莎拉": "机械莎拉",
  "水果趴": "水果趴",
  "发发猴": "发发猴",
  "雅典娜": "雅典娜",
  "荣耀王国": "荣耀王国",
  "亚特兰提斯": "亚特兰提斯",
  "777火焰": "777火焰",
  "大富贵": "大富贵",
  "夏日派对": "夏日派对",
  "狼人": "狼人",
  "亚历山大灯塔": "亚历山大灯塔",
  "可爱狗狗": "可爱狗狗",
  "万兽之王": "万兽之王",
  "巴西嘉年华": "巴西嘉年华",
  "象王": "象王",
  "威尼斯": "威尼斯",
  "火焰皇后": "火焰皇后",
  "吸血鬼": "吸血鬼",
  "超级有钱": "超级有钱",
  "端午节": "端午节",
  "殭尸末日": "僵尸末日",
  "炼丹术": "炼丹术",
  "花好月圆": "花好月圆",
  "七大奇观": "七大奇观",
  "游乐园": "游乐园",
  "月阳之神": "月阳之神",
  "祝融共工": "祝融共工",
  "招财喵喵": "招财喵喵",
  "极地狼嚎": "极地狼嚎",
  "圣诞节": "圣诞节",
  "PS双星・福多多": "PS双星・福多多",
  "音乐家": "音乐家",
  "PS双星・财多多": "PS双星・财多多",
  "宝石之城": "宝石之城",
  "超级有势": "超级有势",
  "PS 不夜城": "PS 不夜城",
  "麻将大侠": "麻将大侠",
  "牛转乾坤": "牛转乾坤",
  "大挑战・玛雅历": "大挑战・玛雅历",
  "大挑战・福禄寿禧": "大挑战・福禄寿禧",
  "黄金周": "黄金周",
  "幸运女郎": "幸运女郎",
  "功夫": "功夫",
  "大挑战・喜从猪来": "大挑战・喜从猪来",
  "水墨武侠": "水墨武侠",
  "超級炸": "超级炸",
  "金鼠迎财神": "金鼠迎财神",
  "二哈当家": "二哈当家",
  "888大富贵": "888大富贵",
  "超级赢": "超级赢",
  "舞娘俱乐部 2": "舞娘俱乐部 2",
  "孔雀王 2": "孔雀王 2",
  "烈火英雄 2": "烈火英雄 2",
  "幸运扑克 2": "幸运扑克 2",
  "墨西哥风采 2": "墨西哥风采 2",
  "百发百粽": "百发百粽",
  "貂蝉发大财": "貂蝉发大财",
  "吕布发大财": "吕布发大财",
  "超级金彩": "超级金彩",
  "魔幻东南亚": "魔幻东南亚",
  "疯狂777": "疯狂777",
  "金币达人": "金币达人",
  "买特色・喜从猪来": "买特色・喜从猪来",
  "买特色・圣诞特快车": "买特色・圣诞特快车",
  "买特色・超级有势": "买特色・超级有势",
  "贵族狗狗巨额赢利线™": "贵族狗狗巨额赢利线™",
  "精灵之夜": "精灵之夜",
  "翡翠王": "翡翠王",
  "摇滚星": "摇滚星",
  "10001夜": "10001夜",
  "1942：天空战士": "1942：天空战士",
  "24小时大奖": "24小时大奖",
  "4人小队": "4人小队",
  "5人家族": "5人家族",
  "777连胜": "777连胜",
  "阿卡德时代": "阿卡德时代",
  "皇家特工": "皇家特工",
  "寻找法老": "寻找法老",
  "上古神兽的祝福": "上古神兽的祝福",
  "水果大爆炸": "水果大爆炸",
  "亚特兰蒂斯": "亚特兰蒂斯",
  "黄金圣典": "黄金圣典",
  "阿兹特克旋转": "阿兹特克旋转",
  "魔法财富": "魔法财富",
  "贝蒂、鲍里斯和啵啵": "贝蒂、鲍里斯和啵啵",
  "炽热群集": "炽热群集",
  "蓝钻风暴": "蓝钻风暴",
  "缤纷炸弹": "缤纷炸弹",
  "赏金突击": "赏金突击",
  "现金或全无": "现金或全无",
  "现金大放送": "现金大放送",
  "现金伏特": "现金伏特",
  "华夏祥瑞": "华夏祥瑞",
  "灰姑娘": "灰姑娘",
  "财富马戏团": "财富马戏团",
  "野兽冲突": "野兽冲突",
  "二十一点": "二十一点",
  "淘气的神灯": "淘气的神灯",
  "水晶镜子": "水晶镜子",
  "达芬奇谜团": "达芬奇谜团",
  "恶魔密码": "恶魔密码",
  "钻石突袭": "钻石突袭",
  "魔幻骰子": "魔幻骰子",
  "圣兽传奇": "圣兽传奇",
  "德古拉觉醒": "德古拉觉醒",
  "海底龙王传说": "海底龙王传说",
  "神龙火焰": "神龙火焰",
  "神龙火焰无限卷轴": "神龙火焰无限卷轴",
  "神龙火焰超级赢利线™": "神龙火焰超级赢利线™",
  "龙之谕超级赢利线™": "龙之谕超级赢利线™",
  "豪华龙运": "豪华龙运",
  "龙之谕Ⅱ": "龙之谕Ⅱ",
  "财富大爆炸": "财富大爆炸",
  "财富大爆炸超级赢利线": "财富大爆炸超级赢利线",
  "老鹰财富": "老鹰财富",
  "魔箭精灵": "魔箭精灵",
  "绿钻风暴": "绿钻风暴",
  "西游寻宝": "西游寻宝",
  "狂欢亡灵节": "狂欢亡灵节",
  "欧式轮盘赌": "欧式轮盘赌",
  "吉祥娃娃": "吉祥娃娃",
  "幸运五星": "幸运五星",
  "幸运五星II": "幸运五星II",
  "火狐传说": "火狐传说",
  "7星高照": "7星高照",
  "幸运宝箱": "幸运宝箱",
  "财富满屋": "财富满屋",
  "财富满屋力量卷轴": "财富满屋力量卷轴",
  "水果宝藏": "水果宝藏",
  "水果皇族": "水果皇族",
  "宝石暴走": "宝石暴走",
  "宝石百搭力量转轴": "宝石百搭力量转轴",
  "宝石记": "宝石记",
  "淘金无限卷轴": "淘金无限卷轴",
  "财神": "财神",
  "金色密码": "金色密码",
  "金色小精灵超级赢利线™": "金色小精灵超级赢利线™",
  "金莲呈祥": "金莲呈祥",
  "金殿丽影": "金殿丽影",
  "金色沙皇": "金色沙皇",
  "贡萨的任务™超级赢利线™": "贡萨的任务™超级赢利线™",
  "幸运大转盘": "幸运大转盘",
  "诸神之锤": "诸神之锤",
  "滑稽金币": "滑稽金币",
  "海神宝藏": "海神宝藏",
  "喧嚣对战": "喧嚣对战",
  "甄妃传奇": "甄妃传奇",
  "杰克的聚宝盆": "杰克的聚宝盆",
  "黄金猎人": "黄金猎人",
  "珠光宝器": "珠光宝器",
  "欢乐小丑": "欢乐小丑",
  "埃及圣甲虫": "埃及圣甲虫",
  "铃儿响叮当": "铃儿响叮当",
  "铃儿响叮当无敌卷轴": "铃儿响叮当无敌卷轴",
  "JingleWaysMegaway": "JingleWaysMegaway",
  "虎王：怪人乔": "虎王：怪人乔",
  "镭射水果": "镭射水果",
  "最后一击": "最后一击",
  "雅典娜传说": "雅典娜传说",
  "王者之剑": "王者之剑",
  "雄狮纳财": "雄狮纳财",
  "巨狮宝藏": "巨狮宝藏",
  "兔子的彩蛋": "兔子的彩蛋",
  "幸运星期五": "幸运星期五",
  "幸运万圣节": "幸运万圣节",
  "幸运恶魔": "幸运恶魔",
  "狂欢啤酒节": "狂欢啤酒节",
  "甜蜜情人节": "甜蜜情人节",
  "幸运魔法师": "幸运魔法师",
  "假面舞会": "假面舞会",
  "玛雅时代": "玛雅时代",
  "巨龙传说": "巨龙传说",
  "金字塔风云": "金字塔风云",
  "超級大贏家": "超级大赢家",
  "翻倍器财富": "翻倍器财富",
  "神秘水果": "神秘水果",
  "神秘卷轴超级赢利线™": "神秘卷轴超级赢利线™",
  "神秘水果II": "神秘水果II",
  "神秘堆叠": "神秘堆叠",
  "轮盘秘语": "轮盘秘语",
  "NarcosMexico": "NarcosMexico",
  "霓虹连接": "霓虹连接",
  "NFTMegaways": "NFTMegaways",
  "深夜骰子": "深夜骰子",
  "忍者传奇": "忍者传奇",
  "命运之路": "命运之路",
  "波斯宝藏": "波斯宝藏",
  "凤凰涅槃": "凤凰涅槃",
  "凤凰涅槃Ⅱ": "凤凰涅槃Ⅱ",
  "猪猪海盗": "猪猪海盗",
  "富豪猪猪™超级赢利线™": "富豪猪猪™超级赢利线™",
  "幽灵海盗": "幽灵海盗",
  "海盗之战": "海盗之战",
  "幽灵海盗超级赢利线": "幽灵海盗超级赢利线",
  "百兽之王": "百兽之王",
  "靴猫剑客": "靴猫剑客",
  "拉神的恩赐": "拉神的恩赐",
  "彩虹的祝福": "彩虹的祝福",
  "彩虹的祝福II": "彩虹的祝福II",
  "财富引擎": "财富引擎",
  "红钻风暴": "红钻风暴",
  "追击劫匪": "追击劫匪",
  "转轴守护者": "转轴守护者",
  "超级卷轴之王": "超级卷轴之王",
  "皇家野兽": "皇家野兽",
  "皇家连胜": "皇家连胜",
  "爬行动物大集合力量卷轴": "爬行动物大集合力量卷轴",
  "狮身人面像之谜": "狮身人面像之谜",
  "里约之星": "里约之星",
  "罗宾汉的野外森林": "罗宾汉的野外森林",
  "火箭对决": "火箭对决",
  "皇家珍宝": "皇家珍宝",
  "击杀": "击杀",
  "白雪派对": "白雪派对",
  "疯狂小镇": "疯狂小镇",
  "梦想好声音": "梦想好声音",
  "相扑大赏": "相扑大赏",
  "森林之神": "森林之神",
  "妖神传说": "妖神传说",
  "劲爆迪斯科": "劲爆迪斯科",
  "列车神偷": "列车神偷",
  "疯帽子": "疯帽子",
  "小丑闪电": "小丑闪电",
  "雷电之子": "雷电之子",
  "索尔的复仇": "索尔的复仇",
  "三国争霸": "三国争霸",
  "水果消消乐": "水果消消乐",
  "水果消消乐之疯狂图腾": "水果消消乐之疯狂图腾",
  "图腾的秘密": "图腾的秘密",
  "图腾的秘密II": "图腾的秘密II",
  "矿洞奇遇": "矿洞奇遇",
  "宝藏大发现力量卷轴": "宝藏大发现力量卷轴",
  "万亿富豪": "万亿富豪",
  "金库怪客": "金库怪客",
  "阿努比斯金库": "阿努比斯金库",
  "维琪冒险记": "维琪冒险记",
  "水果螺旋病毒": "水果螺旋病毒",
  "诸神之战": "诸神之战",
  "百搭之井超级赢利线": "百搭之井超级赢利线",
  "愿望之井": "愿望之井",
  "什么是狐狸超级赢利线": "什么是狐狸超级赢利线",
  "王者集结": "王者集结",
  "自然之神": "自然之神",
  "狂野探险": "狂野探险",
  "功夫神话": "功夫神话",
  "百搭红辣椒卷轴": "百搭红辣椒卷轴",
  "诺德英雄传": "诺德英雄传",
  "百搭时钟": "百搭时钟",
  "斯巴达勇士": "斯巴达勇士",
  "狂野冻原": "狂野冻原",
  "狂野西部诱惑": "狂野西部诱惑",
  "奖金速递": "奖金速递",
  "太阳神之翼": "太阳神之翼",
  "精灵童话": "精灵童话",
  "尤卡坦之謎": "尤卡坦之谜",
  "宙斯闪电力量转轴": "宙斯闪电力量转轴",
  "齐拉德之王": "齐拉德之王",
  "五花爭艷": "五花争艳",
  "复仇者 Tsum Tsum": "复仇者 Tsum Tsum",
  "变装皇后的珠宝": "变装皇后的珠宝",
  "大福大財-財富發發": "大福大财-财富发发",
  "大福大財-黃金選擇": "大福大财-黄金选择",
  "大福大財-鑽石永恆": "大福大财-钻石永恒",
  "大福大財-擊鼓迎福": "大福大财-击鼓迎福",
  "財神到": "财神到",
  "聚福納財-黃金傳奇": "聚福纳财-黄金传奇",
  "侏羅紀公園": "侏罗纪公园",
  "聚福納財-財源滾滾": "聚福纳财-财源滚滚",
  "驚奇馬戲團": "惊奇马戏团",
  "大福大財-盛世牡丹": "大福大财-盛世牡丹",
  "五路財神": "五路财神",
  "聚福納財-鑼鼓生財": "聚福纳财-锣鼓生财",
  "擺脫8": "摆脱8",
  "維京冰風暴": "维京冰风暴",
  "水滸": "水浒",
  "飛龍在天": "飞龙在天",
  "招財童子": "招财童子",
  "白金": "白金",
  "50 雄獅": "50 雄狮",
  "幸運雙子": "幸运双子",
  "萬聖節": "万圣节",
  "湛藍深海": "湛蓝深海",
  "期待黎明": "期待黎明",
  "五龍": "五龙",
  "舞獅爭霸": "舞狮争霸",
  "聚福納財-永恒寶鑽": "聚福纳财-永恒宝钻",
  "太王四神記": "太王四神记",
  "聚福納財-花開富貴": "聚福纳财-花开富贵",
  "龍龍龍": "龙龙龙",
  "真.招財進寶": "真.招财进宝",
  "冒險島": "冒险岛",
  "泰山": "泰山",
  "大吉大利": "大吉大利",
  "九門點天燈": "九门点天灯",
  "極速賽車": "极速赛车",
  "魔法糖果": "魔法糖果",
  "埃及迷城": "埃及迷城",
  "電音大蜘蛛": "电音大蜘蛛",
  "五子戲彌勒": "五子戏弥勒",
  "鑽石角子": "钻石角子",
  "七福神": "七福神",
  "慢搖": "慢摇",
  "勇闖黃金城": "勇闯黄金城",
  "艺妓": "艺妓",
  "狐仙": "狐仙",
  "奧丁之怒": "奥丁之怒",
  "超级8": "超级8",
  "侍忍": "侍忍",
  "探索太阳": "探索太阳",
  "波利之城": "波利之城",
  "魔法门": "魔法门",
  "爱做梦的熊大": "爱做梦的熊大",
  "中华小当家": "中华小当家",
  "战锤40K": "战锤40K",
  "海洋派对": "海洋派对",
  "无限战争": "无限战争",
  "热带海洋": "热带海洋",
  "爱丽丝": "爱丽丝",
  "大富翁": "大富翁",
  "饥饿的鲨鱼": "饥饿的鲨鱼",
  "落樱散华抄": "落樱散华抄",
  "人工少女": "人工少女",
  "太鼓达人": "太鼓达人",
  "光明与深渊": "光明与深渊",
  "金币农场": "金币农场",
  "六狮王朝": "六狮王朝",
  "死党的游戏": "死党的游戏",
  "秋秋羊": "秋秋羊",
  "军事风云": "军事风云",
  "要听神明的话": "要听神明的话",
  "旅行青蛙": "旅行青蛙",
  "阴阳师": "阴阳师",
  "僵尸猎人": "僵尸猎人",
  "天天过马路": "天天过马路",

  "财宝宫殿": "财宝宫殿",
  "闪电XUP": "闪电XUP",
  "篮球巨星火力全开": "篮球巨星火力全开",
  "趣味蜜蜂™": "趣味蜜蜂™",
  "西域黄金": "西域黄金",
  "古代财富 Poseidon Megaways™": "古代财富 Poseidon Megaways™",
  "歹徒通缉令": "歹徒通缉令",
  "奥林匹斯編年史XUP": "奥林匹斯編年史XUP",
  "777电光火石": "777电光火石",
  "神奇连环阿波罗": "神奇连环阿波罗",
  "神圣财富-赫利俄斯": "神圣财富-赫利俄斯",
  "阿瓦隆": "阿瓦隆",
  "非洲XUP": "非洲XUP",
  "深海派对": "深海派对",
  "4钻石蓝调 MEGAWAYS": "4钻石蓝调 MEGAWAYS",
  "三叶草福尔摩斯 Megaways™": "三叶草福尔摩斯 Megaways™",
  "奇遇宫殿": "奇遇宫殿",
  "宝石转轴豪华版": "宝石转轴豪华版",
  "刺客之月": "刺客之月",
  "9个烈焰面具 HyperSpins™": "9个烈焰面具 HyperSpins™",
  "荒野垂钓": "荒野垂钓",
  "现金与财富 Megaways™": "现金与财富 Megaways™",
  "布鲁诺的加洛黄金 Megaways": "布鲁诺的加洛黄金 Megaways",
  "黄金闪电": "黄金闪电",
  "美丽骷髅": "美丽骷髅",
  "777 超级 BIG BuildUp™ 豪华版™": "777 超级 BIG BuildUp™ 豪华版™",
  "雄鹰之翼": "雄鹰之翼",
  "烈焰战狼Megaways™": "烈焰战狼Megaways™",
  "银背乘数山": "银背乘数山",
  "9个烈焰面具": "9个烈焰面具",
  "海洋珍宝": "海洋珍宝",
  "一万零一夜": "一万零一夜",
  "芬恩与糖果旋转": "芬恩与糖果旋转",
  "仙宫宝石": "仙宫宝石",
  "亡命对决2": "亡命对决2",
  "蒸汽之塔™": "蒸汽之塔™",
  "炫目宝石™": "炫目宝石™",
  "神秘水果豪华版": "神秘水果豪华版",
  "赏金冲刺2": "赏金冲刺2",
  "帕台农神庙：探索永生™": "帕台农神庙：探索永生™",
  "热线2": "热线2",
  "现金争锋™": "现金争锋™",
  "老虎机之王™": "老虎机之王™",
  "银背大猩猩黄金": "银背大猩猩黄金",
  "摇滚连锁": "摇滚连锁",
  "亡命对决2™ 特色游戏购买": "亡命对决2™ 特色游戏购买",
  "摩托头": "摩托头",
  "制造混乱": "制造混乱",
  "天赐好运™巨额路线™": "天赐好运™巨额路线™",
  "童话传说：魔镜™": "童话传说：魔镜™",
  "好运Clusterbuster™": "好运Clusterbuster™",
  "塞伦盖蒂之王": "塞伦盖蒂之王",
  "枪炮玫瑰视频老虎机™": "枪炮玫瑰视频老虎机™",
  "德古拉™": "德古拉™",
  "贵族狗狗": "贵族狗狗",
  "钓鱼大亨": "钓鱼大亨",
  "放克大师": "放克大师",
  "吸血男爵Megaways™": "吸血男爵Megaways™",
  "财富满屋 Power Reels™": "财富满屋 Power Reels™",
  "双子卷轴™": "双子卷轴™",
  "贡佐的探险™": "贡佐的探险™",
  "科尼利厄斯": "科尼利厄斯",
  "猩猩王国™": "猩猩王国™",
  "斯库达摩尔的超级赌注": "斯库达摩尔的超级赌注",
  "钱多多": "钱多多",
  "甜蜜果儿™": "甜蜜果儿™",
  "贡琪塔的任务": "贡琪塔的任务",
  "古岩的奥秘™": "古岩的奥秘™",
  "锦鲤公主™": "锦鲤公主™",
  "菲恩的金酒馆": "菲恩的金酒馆",
  "特洛伊之神": "特洛伊之神",
  "水果商店™ 巨额路线™": "水果商店™ 巨额路线™",
  "纸杯蛋糕": "纸杯蛋糕",
  "龙袍": "龙袍",
  "金色魔法书": "金色魔法书",
  "阿帕切之路": "阿帕切之路",
  "失窃珍宝": "失窃珍宝",
  "贡萨的任务MEGAWAYS™": "贡萨的任务MEGAWAYS™",
  "神龙火焰MEGAWAYS™": "神龙火焰MEGAWAYS™",
  "失落遗迹™": "失落遗迹™",
  "拯救猫科巨额赢利线™": "拯救猫科巨额赢利线™",
  "童话传说：小红帽": "童话传说：小红帽",
  "万圣节杰克™": "万圣节杰克™",
  "卷轴神偷™": "卷轴神偷™",
  "米德加德的财富：土地和扩张™": "米德加德的财富：土地和扩张™",
  "灯光™": "灯光™",
  "罗马：黄金时代™": "罗马：黄金时代™",
  "寻蝶记": "寻蝶记",
  "竞速：多重狂欢™": "竞速：多重狂欢™",
  "神剑™": "神剑™",
  "丛林精灵：百搭互换": "丛林精灵：百搭互换",
  "足球冠军杯™": "足球冠军杯™",
  "梦幻奶昔超极限": "梦幻奶昔超极限",
  "巨龙超级群集™": "巨龙超级群集™",
  "阿罗哈！圣诞™": "阿罗哈！圣诞™",
  "荒野之地™": "荒野之地™",
  "水果商店™": "水果商店™",
  "富豪猪猪MEGAWAYS™": "富豪猪猪MEGAWAYS™",
  "神话少女™": "神话少女™",
  "黄金之神：无限卷轴": "黄金之神：无限卷轴",
  "拉塞达财富": "拉塞达财富",
  "性感歌舞厅": "性感歌舞厅",
  "百搭之井MEGAWAYS™": "百搭之井MEGAWAYS™",
  "玛雅崛起™": "玛雅崛起™",
  "超级前锋™": "超级前锋™",
  "寻蝶记2": "寻蝶记2",
  "淘金": "淘金",
  "黄金炸弹客": "黄金炸弹客",
  "怒海狂涛™": "怒海狂涛™",
  "蛋糕与冰激凌": "蛋糕与冰激凌",
  "爱尔兰幸运罐子™": "爱尔兰幸运罐子™",
  "吉米·亨德里克斯在线老虎机™": "吉米·亨德里克斯在线老虎机™",
  "小丑专业版™": "小丑专业版™",
  "幽灵海盗MEGAWAYS™": "幽灵海盗MEGAWAYS™",
  "精灵菲恩与漩涡转盘": "精灵菲恩与漩涡转盘",
  "德鲁伊之梦™": "德鲁伊之梦™",
  "童话传说：韩赛尔和格雷特™": "童话传说：韩赛尔和格雷特™",
  "影子密会": "影子密会",
  "杰克·汉墨2™": "杰克·汉墨2™",
  "雅典 MegaWays™": "雅典 MegaWays™",
  "巨魔奖池5000™": "巨魔奖池5000™",
  "狼祸™": "狼祸™",
  "戈登·拉姆齐地狱厨房": "戈登·拉姆齐地狱厨房",
  "霓虹星光™": "霓虹星光™",
  "财富法典™": "财富法典™",
  "推动神庙": "推动神庙",
  "黄金炸弹客Megaways": "黄金炸弹客Megaways",
  "水果转盘™": "水果转盘™",
  "皇家钻石": "皇家钻石",
  "双重堆叠™": "双重堆叠™",
  "太空大战2力量指数": "太空大战2力量指数",
  "圣诞铃铛转盘™": "圣诞铃铛转盘™",
  "邋遢鸭™": "邋遢鸭™",
  "龙之谕": "龙之谕",
  "马蒂克神蛋™": "马蒂克神蛋™",
  "斗牛狂奔": "斗牛狂奔",
  "阿罗哈！符号串赢奖™": "阿罗哈！符号串赢奖™",
  "星光四射™": "星光四射™",
  "圣殿秘宝Power Reels™": "圣殿秘宝Power Reels™",
  "财富之翼™": "财富之翼™",
  "马蒂克现金™": "马蒂克现金™",
  "富贵蜂巢": "富贵蜂巢",
  "水果商店圣诞版™": "水果商店圣诞版™",
  "黑暗之王：禁忌财富": "黑暗之王：禁忌财富",
  "非同质化代币": "非同质化代币",
  "10001夜Megaways™": "10001夜Megaways™",
  "赏金冲刺™": "赏金冲刺™",
  "元素：觉醒™": "元素：觉醒™",
  "奇幻兔子洞": "奇幻兔子洞",
  "捣蛋万圣节": "捣蛋万圣节",
  "吸血男爵II™": "吸血男爵II™",
  "财富小猪™": "财富小猪™",
  "幼狼™": "幼狼™",
  "皮纳塔盛会™": "皮纳塔盛会™",
  "神秘水果大中奖": "神秘水果大中奖",
  "杰克和魔豆™": "杰克和魔豆™",
  "狂野集市™": "狂野集市™",
  "花朵™": "花朵™",
  "死神殿": "死神殿",
  "魅惑女王": "魅惑女王",
  "阿努比斯之月": "阿努比斯之月",
  "三重辣椒": "三重辣椒",
  "辣椒的道": "辣椒的道",
  "狂野圣诞": "狂野圣诞",
  "野性霸主": "野性霸主",
  "四个王牌": "四个王牌",
  "财富之轮": "财富之轮",
  "圣诞节之伸手奖金购买": "圣诞节之伸手奖金购买",
  "足球女将": "足球女将",
  "水果超级新星 60": "水果超级新星 60",
  "布袋卷轴": "布袋卷轴",
  "怪奇旅游": "怪奇旅游",
  "踩地雷": "踩地雷",
  "骷颅奇兵": "骷颅奇兵",
  "梦想之谷": "梦想之谷",
  "最大鱼获": "最大鱼获",
  "足球单人前锋": "足球单人前锋",
  "死神殿奖金购买": "死神殿奖金购买",
  "野性霸主奖金购买": "野性霸主奖金购买",
  "四季美人": "四季美人",
  "水果超级新星 30": "水果超级新星 30",
  "骑驴扫弹": "骑驴扫弹",
  "火箭之星": "火箭之星",
  "冲浪区": "冲浪区",
  "龙之酒馆奖金购买": "龙之酒馆奖金购买",
  "皇帝陵墓": "皇帝陵墓",
  "东方神秘": "东方神秘",
  "森林梦境": "森林梦境",
  "钱币铸造机": "钱币铸造机",
  "运气循环奖金购买": "运气循环奖金购买",
  "血腥珠宝": "血腥珠宝",
  "欧洲转运奖金购买": "欧洲转运奖金购买",
  "辛迪加": "辛迪加",
  "命运符文": "命运符文",
  "圣诞节之伸手": "圣诞节之伸手",
  "迷宫：渴望权力": "迷宫：渴望权力",
  "好运之卡": "好运之卡",
  "藏宝任务": "藏宝任务",
  "多汁宝石": "多汁宝石",
  "海妖之金奖金购买": "海妖之金奖金购买",
  "饥饿之夜": "饥饿之夜",
  "水果新星": "水果新星",
  "鬼船海盗": "鬼船海盗",
  "点球系列": "点球系列",
  "刮刮卡": "刮刮卡",
  "史诗冲突": "史诗冲突",
  "冒险飞船": "冒险飞船",
  "水果迪斯科": "水果迪斯科",
  "无限愿望": "无限愿望",
  "爱尔兰画卷": "爱尔兰画卷",
  "幸运轮": "幸运轮",
  "弹球游戏": "弹球游戏",
  "海上旋转": "海上旋转",
  "艾伦的财富": "艾伦的财富",
  "足球刮刮卡": "足球刮刮卡",
  "毛怪复仇者": "毛怪复仇者",
  "幸运七": "幸运七",
  "愉快宝藏": "愉快宝藏",
  "努克世界": "努克世界",
  "甜甜食糖": "甜甜食糖",
  "无限宝藏奖金购买": "无限宝藏奖金购买",
  "埃及众神": "埃及众神",
  "比大小": "比大小",
  "幸运七特辑": "幸运七特辑",
  "基诺圣诞猫": "基诺圣诞猫",
  "篮球联盟": "篮球联盟",
  "狂野子弹": "狂野子弹",
  "果冻啾啾": "果冻啾啾",
  "圣贤遗产奖金购买": "圣贤遗产奖金购买",
  "地城探险": "地城探险",
  "美猴王": "美猴王",
  "糖果梦": "糖果梦",
  "水果超级新星 40": "水果超级新星 40",
  "冰狂": "冰狂",
  "基诺之书": "基诺之书",
  "糖果梦:甜蜜星球": "糖果梦:甜蜜星球",
  "帕特里克之魔法场": "帕特里克之魔法场",
  "遗忘的寓言": "遗忘的寓言",
  "运气循环": "运气循环",
  "点球轮盘": "点球轮盘",
  "光之树": "光之树",
  "卢克斯之影": "卢克斯之影",
  "抛硬币": "抛硬币",
  "龙之酒馆": "龙之酒馆",
  "精灵公主": "精灵公主",
  "罗宾逊": "罗宾逊",
  "午夜派对": "午夜派对",
  "时间之轮": "时间之轮",
  "古老传说": "古老传说",
  "多汁宝石奖金购买": "多汁宝石奖金购买",
  "水手猜奖": "水手猜奖",
  "自豪之战": "自豪之战",
  "豚宝奇兵": "豚宝奇兵",
  "法老诅咒奖金购买": "法老诅咒奖金购买",
  "乐透吧": "乐透吧",
  "荷鲁斯的崛起": "荷鲁斯的崛起",
  "复活之夜": "复活之夜",
  "冠军腰带奖金购买": "冠军腰带奖金购买",
  "E.T.军团": "E.T.军团",
  "疯狂宝藏": "疯狂宝藏",
  "寻找女王": "寻找女王",
  "水果超级新星 100": "水果超级新星 100",
  "红玫瑰殿堂奖金购买": "红玫瑰殿堂奖金购买",
  "冬之星奖金购买": "冬之星奖金购买",
  "最大鱼获金购买": "最大鱼获金购买",
  "金钱暴": "金钱暴",
  "雷霆之殿": "雷霆之殿",
  "美食盛宴": "美食盛宴",
  "骰吧": "骰吧",
  "布袋卷轴奖金购买": "布袋卷轴奖金购买",
  "驯兽宝贝": "驯兽宝贝",
  "扭转胜利": "扭转胜利",
  "水果超级新星": "水果超级新星",
  "罗宾汉": "罗宾汉",
  "爆炸水果": "爆炸水果",
  "史诗传说": "史诗传说",
  "幸运女孩": "幸运女孩",
  "水果超级新星 80": "水果超级新星 80",
  "疯狂木乃伊": "疯狂木乃伊",
  "海妖之金": "海妖之金",
  "战车": "战车",
  "朱雀宝藏": "朱雀宝藏",
  "盗墓笔记": "盗墓笔记",
  "经典拉霸": "经典拉霸",
  "魔童降世": "魔童降世",
  "五号宝藏": "五号宝藏",
  "龙之财富": "龙之财富",
  "决战世界杯": "决战世界杯",
  "经典拉霸2": "经典拉霸2",
  "神灯传说": "神灯传说",
  "金色道虎": "金色道虎",
  "九线拉王": "九线拉王",
  "万圣狂欢夜": "万圣狂欢夜",
  "水浒Q传": "水浒Q传",
  "钻石永恒": "钻石永恒",
  "真金拉霸": "真金拉霸",
  "财富连连": "财富连连",
  "金吉报喜": "金吉报喜",
  "寻妖录": "寻妖录",
  "百万金轮": "百万金轮",
  "幸运魔力球": "幸运魔力球",
  "遗迹探险": "遗迹探险",
  "大富大贵": "大富大贵",
  "金鼓迎福": "金鼓迎福",
  "金色道龙": "金色道龙",
  "王国纪元": "王国纪元",
  "狩猎日记": "狩猎日记",
  "盗贼之海": "盗贼之海",
  "魔法少女": "魔法少女",
  "财神的宝藏": "财神的宝藏",
  "特洛伊木马": "特洛伊木马",
  "多福多财街机版": "多福多财街机版",
  "哈利波特": "哈利波特",
  "无尽宝藏": "无尽宝藏",
  "大闹天宫": "大闹天宫",
  "糖果世界": "糖果世界",
  "超级马里奥": "超级马里奥",
  "水果超市": "水果超市",
  "麻将来了3": "麻将来了3",
  "牛气冲天": "牛气冲天",
  "长坂坡英雄": "长坂坡英雄",
  "疯狂动物城": "疯狂动物城",
  "丧尸之战": "丧尸之战",
  "黄金矿工": "黄金矿工",
  "水果发发发": "水果发发发",
  "八宝黄龙": "八宝黄龙",
  "疯狂小玛莉": "疯狂小玛莉",
  "皇室战争": "皇室战争",
  "闪电狗": "闪电狗",
  "冰川时代": "冰川时代",
  "魔力宝箱": "魔力宝箱",
  "渔童钓宝": "渔童钓宝",
  "冰雪奇缘": "冰雪奇缘",
  "疯狂刮刮乐": "疯狂刮刮乐",
  "哈希大小": "哈希大小",
  "HILO翻牌": "HILO翻牌",
  "幸运哈希": "幸运哈希",
  "哈希单双": "哈希单双",
  "T台美女秀": "T台美女秀",
  "Bingo": "Bingo",
  "极限跳伞": "极限跳伞",
  "幸运庄闲": "幸运庄闲",
  "哈希牛牛": "哈希牛牛"
};
// 捕鱼子游戏的翻译 简体中文
const fish_cn = {
  金蝉捕鱼: '金蝉捕鱼',
  李逵劈鱼: '李逵劈鱼',
  人鱼传说: '人鱼传说',
  大圣捕鱼: '大圣捕鱼',
  寻龙夺宝: '寻龙夺宝',
  大闹天宫: '大闹天宫',
  捕鱼王中王: '捕鱼王中王',
  捕鸟联盟: '捕鸟联盟',
  捕鱼联盟: '捕鱼联盟',
  龙王捕鱼: '龙王捕鱼',
  龙王捕鱼2: '龙王捕鱼2',
  财神捕鱼: '财神捕鱼',
  五龙捕鱼: '五龙捕鱼',
  美人捕鱼: '美人捕鱼',
  天天捕鱼: '天天捕鱼',
  捕鱼来了3D: '捕鱼来了3D',
  皇金渔场: '皇金渔场',
  皇金渔场2: '皇金渔场2',
  美人鱼传说: '美人鱼传说',
  猎鼠达人3D: '猎鼠达人3D',
  魔法王者: '魔法王者',
  欢乐捕鱼: '欢乐捕鱼',
  捕鸟达人: '捕鸟达人',
  雷霆战警: '雷霆战警',
  雷电战机: '雷电战机',
  一炮捕鱼: '一炮捕鱼',
  '3D美人鱼': '3D美人鱼',
  '3D海盗来了': '3D海盗来了',
  千炮捕鱼王: '千炮捕鱼王',
  '3D捕鱼': '3D捕鱼',
  '3D捕鱼王中王': '3D捕鱼王中王',
  金蟾海王2: '金蟾海王2',
  大闹天宫2: '大闹天宫2',
  大闹天宫1: '大闹天宫1',
  金蟾捕鱼: '金蟾捕鱼',
};
// 棋牌子游戏的翻译
const porker_cn = {
  骰子扑克: '骰子扑克',
  万圣夜: '万圣夜',
  欢乐六星彩: '欢乐六星彩',
  "看牌抢庄牛牛": "看牌抢庄牛牛",
  "二八杠": "二八杠",
  "李逵劈鱼": "李逵劈鱼",
  "单挑牛牛": "单挑牛牛",
  "21点": "21点",
  "斗地主": "斗地主",
  "赌场扑克": "赌场扑克",
  "百人骰宝": "百人骰宝",
  "押庄龙虎": "押庄龙虎",
  "万人炸金花": "万人炸金花",
  "鱼虾蟹": "鱼虾蟹",
  "奔驰宝马": "奔驰宝马",
  "三公": "三公",
  "抢庄牌九": "抢庄牌九",
  "红包捕鱼": "红包捕鱼",
  "水果机": "水果机",
  "德州扑克": "德州扑克",
  "二人麻将": "二人麻将",
  "十三水": "十三水",
  "跑得快": "跑得快",
  "血流成河": "血流成河",
  "五星宏辉": "五星宏辉",
  "百人牛牛": "百人牛牛",
  "抢庄牛牛": "抢庄牛牛",
  "炸金花": "炸金花",
  "红黑大战": "红黑大战",
  "金鲨银鲨": "金鲨银鲨",
  "疯狂抢庄牛牛": "疯狂抢庄牛牛",
  "通比牛牛": "通比牛牛",
  "押宝抢庄牛牛": "押宝抢庄牛牛",
  "极速炸金花": "极速炸金花",
  "炸金牛": "炸金牛",
  "百家乐": "百家乐",
  "港式梭哈": "港式梭哈",
  "森林舞会": "森林舞会",
  "血战骰宝": "血战骰宝",
  "万人推筒子": "万人推筒子",
  "骰子牛牛": "骰子牛牛",
  "龙虎斗": "龙虎斗",
  "看三张抢庄牛牛": "看三张抢庄牛牛",
  "捕鱼大作战": "捕鱼大作战",
  "血战到底": "血战到底",
  "看四张抢庄牛牛": "看四张抢庄牛牛",
  "宝石消消乐": "宝石消消乐",
  "癞子牛牛": "癞子牛牛",
  "抢庄选三张": "抢庄选三张",
  "头号玩家": "头号玩家",
  "欢乐炸金花": "欢乐炸金花",
  "抢红包": "抢红包",
  "豪车漂移": "豪车漂移",
  "财神到": "财神到",
  "好友包房": "好友包房",
  "十点半": "十点半",
  "极速赛车": "极速赛车",
  "黑红梅方": "黑红梅方",
  "古怪猴子": "古怪猴子",
  "上庄百人牛牛": "上庄百人牛牛",
  "大话骰斋劈": "大话骰斋劈",
  "骰宝抢庄牛牛": "骰宝抢庄牛牛",
  "骰宝抢庄三公": "骰宝抢庄三公",
  "骰宝通比三公": "骰宝通比三公",
  "骰宝红黑单双": "骰宝红黑单双",
  "骰宝血战到底": "骰宝血战到底",
  "大话骰 067": "大话骰 067",
  "二人牛牛": "二人牛牛",
  "必下德州": "必下德州",
  "开心翻翻乐": "开心翻翻乐",
  "龙王捕鱼": "龙王捕鱼",
  "多财多福": "多财多福",
  "竞咪楚汉德州": "竞咪楚汉德州",
  "推筒子": "推筒子",
  "加倍斗地主": "加倍斗地主",
  "保险楚汉德州": "保险楚汉德州",
  "百人三公": "百人三公",
  "开心摇摇乐": "开心摇摇乐",
  "广东推倒胡": "广东推倒胡",
  "二十一点": "二十一点",
  "广东鸡平胡": "广东鸡平胡",
  "经典抢庄牛牛": "经典抢庄牛牛",
  "大话骰": "大话骰",
  "幸运五张": "幸运五张",
  "抢庄 21 点": "抢庄 21 点",
  "抢庄三张": "抢庄三张",
  "拼三张": "拼三张",
  "看牌抢庄": "看牌抢庄",
  "经典牛牛": "经典牛牛",
  "幸运 21 点": "幸运 21 点",
  "德州 2+3": "德州 2+3",
  "多人 21 点": "多人 21 点",
  "欢乐龙虎": "欢乐龙虎",
  "四人通比牛牛": "四人通比牛牛",
  "诈牛牛": "诈牛牛",
  "看三张抢庄炸金花": "看三张抢庄炸金花",
  "百变牛牛": "百变牛牛",
  "运气牛牛": "运气牛牛",
  "百人牌九": "百人牌九",
  "对战牛牛": "对战牛牛",
  "通杀牛牛": "通杀牛牛",
  "看牌抢牛": "看牌抢牛",
  "通比梭哈": "通比梭哈",
  "四人梭哈": "四人梭哈",
  "红包扫雷": "红包扫雷",
  "斗地主比赛": "斗地主比赛",
  "水浒传": "水浒传",
  "九线拉王": "九线拉王",
  "国际博乐21点": "国际博乐21点",
  "博乐牛牛": "博乐牛牛",
  "博乐三公": "博乐三公",
  "博乐炸金花": "博乐炸金花",
  "博乐大众麻将": "博乐大众麻将",
  "博乐21点": "博乐21点",
  "博乐广东麻将": "博乐广东麻将",
  "博乐湖南转转麻将": "博乐湖南转转麻将",
  "博乐杭州麻将": "博乐杭州麻将",
  "博乐卡五星麻将": "博乐卡五星麻将",
  "博乐贵阳捉鸡麻将": "博乐贵阳捉鸡麻将",
  "博乐二人麻将": "博乐二人麻将",
  "老虎机": "老虎机",
  "国际博乐百草": "国际博乐百草",
  "国际博乐百草2": "国际博乐百草2",
  "国际博乐13水": "国际博乐13水",
  "国际百家乐": "国际百家乐",
  "抢庄骰宝": "抢庄骰宝",
  "骰宝": "骰宝",
  "梭哈牛牛": "梭哈牛牛",
  "疯狂点子牛": "疯狂点子牛",
  "彩金牛牛": "彩金牛牛",
  "换三张牛牛": "换三张牛牛",
  "翻倍血流": "翻倍血流",
  "百人百家乐": "百人百家乐",
  "3D世界杯": "3D世界杯",
  "3D圣城风云": "3D圣城风云",
  "3D布法罗山谷": "3D布法罗山谷",
  "看四张牛牛": "看四张牛牛",
  "百人推筒子": "百人推筒子",
  "通比牌九": "通比牌九",
  "欧式轮盘": "欧式轮盘",
  "3D抢庄牛牛": "3D抢庄牛牛",
  "3D炸金花": "3D炸金花",
  "德州扑克(前注场)": "德州扑克(前注场)",
  "极速斗地主": "极速斗地主",
  "经典水果": "经典水果",
  "3D黄金国度": "3D黄金国度",
  "宝石消消消": "宝石消消消",
  "猴王传奇": "猴王传奇",
  "埃及夺宝": "埃及夺宝",
  "看4张抢庄牛牛": "看4张抢庄牛牛",
  "幸运777": "幸运777",
  "万人金花": "万人金花",
  "麻辣火锅": "麻辣火锅",
  "皇家连环炮": "皇家连环炮",
  "刮刮乐": "刮刮乐",
  "百人21点": "百人21点",
  "渔场大亨": "渔场大亨",
  "寻宝奇航": "寻宝奇航",
  "百草": "百草",
  "双骰": "双骰",
  "2人麻将": "2人麻将",
  "印度三张牌": "印度三张牌",
  "色碟": "色碟",
  "猜AB": "猜AB",
  "拉米纸牌": "拉米纸牌",
  "幸运骰子": "幸运骰子",
  "梭哈": "梭哈",
  "番摊": "番摊",
  "泰式比高低": "泰式比高低",
  "鱼虾蟹2": "鱼虾蟹2",
  "鱼虾蚝2": "鱼虾蚝2",
  "龙虎2": "龙虎2",
  "番摊2": "番摊2",
  "越式鱼虾蟹": "越式鱼虾蟹",
  "越式大小": "越式大小",
  "快乐彩": "快乐彩",
  "扑克轮盘": "扑克轮盘",
  "泰式鱼虾蟹": "泰式鱼虾蟹",
  "色碟2": "色碟2",
  "番摊经典": "番摊经典",
  "三重轮盘": "三重轮盘",
  "水果轮盘": "水果轮盘",
  "德州牛仔": "德州牛仔",
  "经典炸金花": "经典炸金花",
  "欢乐德州": "欢乐德州",
  "欢乐红包": "欢乐红包",
  "欢乐麻将": "欢乐麻将",
  "抢庄牛牛3D": "抢庄牛牛3D",
  "欢乐麻将3D": "欢乐麻将3D",
  "乐斗牛魔王3D": "乐斗牛魔王3D",
  "关秦龙虎斗": "关秦龙虎斗",
  "跑车联盟": "跑车联盟",
  "疯狂牛牛": "疯狂牛牛",
  "疯狂炸金花": "疯狂炸金花",
  "超级海王": "超级海王",
  "超级捕鱼": "超级捕鱼",
  "三国志": "三国志",
  "发财神": "发财神",
  "西游记": "西游记",
  "俄罗斯转盘": "俄罗斯转盘",
  "猴王争霸": "猴王争霸",
  "红中麻将": "红中麻将",
  "抢庄三公": "抢庄三公",
  "看四张抢庄牛": "看四张抢庄牛",
  "百变随机牛": "百变随机牛",
  "百变6张牛": "百变6张牛",
  "清纯公主的秘密": "清纯公主的秘密",
  "经典21点": "经典21点",
  "牌九": "牌九",
  "阿三猜数": "阿三猜数",
  "抢庄炸金花": "抢庄炸金花",
  "明牌炸金花": "明牌炸金花",
  "抢庄21点": "抢庄21点",
  "疯狂马戏团": "疯狂马戏团",
  "飞禽走兽": "飞禽走兽",
  "一元夺宝": "一元夺宝",
  "百人二八杠": "百人二八杠",
  "百人扎金花": "百人扎金花",
  "寳石世界": "宝石世界",
  "戰棋": "战棋",
  "招財福袋": "招财福袋",
  "鬼王送財": "鬼王送财",
  "金玉滿堂": "金玉满堂",
  "豆腐屋奈奈致命诱惑": "豆腐屋奈奈致命诱惑",
  "明日花潮吹升天": "明日花潮吹升天",
  "三上悠亚海滩甜心": "三上悠亚海滩甜心",
  "神之乳Rion": "神之乳Rion",
  "旬果的淫乱教室": "旬果的淫乱教室",
  "火热777": "火热777",
  "海盗传奇": "海盗传奇",
  "我爱黑色会": "我爱黑色会",
  "天使萌萌哒": "天使萌萌哒",
  "优的女仆贴身服务": "优的女仆贴身服务",
  "千菜浴池旁的疯狂抽插": "千菜浴池旁的疯狂抽插",
  "被凌辱的失学少女": "被凌辱的失学少女",
  "贵妇的外遇初体验": "贵妇的外遇初体验",
  "发发发": "发发发",
  "招财福娃": "招财福娃",
  "关云长": "关云长",
  "不为人知の绝伦女帝": "不为人知の绝伦女帝",
  "绝品人妻的完熟BODY": "绝品人妻的完熟BODY",
  "特训♡体欲少女": "特训♡体欲少女",
  "糖果传奇": "糖果传奇",
  "蹦迪": "蹦迪",
  "武則天": "武则天",
  "麻將胡胡胡": "麻将胡胡胡",
  "愛爾蘭精靈": "爱尔兰精灵",
  "梅杜莎": "梅杜莎",
  "天神宙斯": "天神宙斯",
  "草原之王": "草原之王",
  "阿拉丁": "阿拉丁",
  "財神到": "财神到",
  "百人龙虎": "百人龙虎",
  "至尊五张": "至尊五张",
  "咪牌抢庄牛牛": "咪牌抢庄牛牛",
  "抢庄选三张(三公)": "抢庄选三张(三公)",
  "抢庄选三张(炸金花)": "抢庄选三张(炸金花)",
  "百变抢庄牛牛": "百变抢庄牛牛",
  "红黑斗牛": "红黑斗牛",
  "极速三公": "极速三公",
  "印度三张": "印度三张",
  "明牌牛牛": "明牌牛牛",
  "欢乐牛牛": "欢乐牛牛",
  "爆点牛牛": "爆点牛牛",
  "通比三公": "通比三公",
  "爆点三公": "爆点三公",
  "三公大吃小": "三公大吃小",
  "广东麻将": "广东麻将",
  "血流麻将": "血流麻将",
  "决战21点": "决战21点",
  "爆点百家乐": "爆点百家乐",
  "二人斗地主": "二人斗地主",
  "365扑克": "365扑克",
  "8张": "8张",
  "印度拉米": "印度拉米",
  "印度骰宝": "印度骰宝",
  "安打巴哈": "安打巴哈",
  "八九点": "八九点",
  "西遊爭霸M": "西游争霸M",
  "Rummy": "Rummy",
  "TeenPatti Joker": "TeenPatti Joker",
  "數字之王": "数字之王",
  "撲克之王": "扑克之王",
  "龍虎鬥": "龙虎斗",
  "iRich Bingo": "IRich Bingo",
  "7上7下": "7上7下",
  "TeenPatti": "TeenPatti",
  "AK47": "AK47",
  "Andar Bahar": "Andar Bahar",
  "Callbreak": "Callbreak"
}

const mgdz_cn = {
  "幸运双星 PowerClusters": "幸运双星 PowerClusters",
  "巨额黄金": "巨额黄金",
  "铂金鲨鱼": "铂金鲨鱼",
  "瓦特博士": "瓦特博士",
  "幸运小龙": "幸运小龙",
  "开罗神后": "开罗神后",
  "新水浒传": "新水浒传",
  "万达金福娃捕鱼": "万达金福娃捕鱼",
  "全能宙斯百搭": "全能宙斯百搭",
  "富豪老虎": "富豪老虎",
  "金罐淘金热": "金罐淘金热",
  "奥林匹斯 编年史 宙斯": "奥林匹斯 编年史 宙斯",
  "黄金闪电 终极版": "黄金闪电 终极版",
  "众神和金字塔": "众神和金字塔",
  "龙之宝藏": "龙之宝藏",
  "火焰与玫瑰欢乐小丑": "火焰与玫瑰欢乐小丑",
  "9个魔力豆子": "9个魔力豆子",
  "万达快乐岛捕鱼": "万达快乐岛捕鱼",
  "金罐钓钓乐黄金闪电": "金罐钓钓乐黄金闪电",
  "冰球突破十万路": "冰球突破十万路",
  "碰碰麻将": "碰碰麻将",
  "神秘宝藏": "神秘宝藏",
  "太阳神女王POWER COMBO": "太阳神女王POWERCOMBO",
  "疯狂宝石烈焰": "疯狂宝石烈焰",
  "永恒寡妇": "永恒寡妇",
  "铁砧&矿石": "铁砧&矿石",
  "非常嫌疑犯": "非常嫌疑犯",
  "阿斯加德之火": "阿斯加德之火",
  "提基大爆炸": "提基大爆炸",
  "9罐黄金MEGAWAYS": "9罐黄金MEGAWAYS",
  "万达金霸王捕鱼": "万达金霸王捕鱼",
  "奥林匹斯斗士": "奥林匹斯斗士",
  "亚马孙失落的黄金": "亚马孙失落的黄金",
  "三伏天": "三伏天",
  "安德瓦里:魔法戒指": "安德瓦里：魔法戒指",
  "快乐渔夫": "快乐渔夫",
  "魔法小丑": "魔法小丑",
  "暴富之路": "暴富之路",
  "疯狂酒馆": "疯狂酒馆",
  "飞翔X": "飞翔X",
  "全能宙斯帝国": "全能宙斯帝国",
  "僵尸大战": "僵尸大战",
  "转转糖果": "转转糖果",
  "神奇法老": "神奇法老",
  "甜蜜糖果热潮": "甜蜜糖果热潮",
  "罗马:黄金之战": "罗马：黄金之战",
  "财富派克黄金": "财富派克黄金",
  "趣味蜜蜂": "趣味蜜蜂",
  "万达金财神捕鱼": "万达金财神捕鱼",
  "辣椒堆叠乐": "辣椒堆叠乐",
  "幸运香蕉": "幸运香蕉",
  "布鲁诺 的加洛 黄金 Megaways": "布鲁诺 的加洛 黄金 Megaways",
  "妖精出击": "妖精出击",
  "火焰与玫瑰小丑": "火焰与玫瑰小丑",
  "快乐招财猫": "快乐招财猫",
  "黄金宝箱:POWERCOMBO": "黄金宝箱: POWER COMBO",
  "极度野火奖金": "极度野火奖金",
  "欢乐糖果百搭": "欢乐糖果百搭",
  "烈焰战狼 Megaways": "烈焰战狼 Megaways",
  "黄金闪电": "黄金闪电",
  "龙之堡垒": "龙之堡垒",
  "心动烟花祭": "心动烟花祭",
  "野牛圆月": "野牛圆月",
  "特洛伊王国": "特洛伊王国",
  "奥林匹斯山之主": "奥林匹斯山之主",
  "Playboy 百搭": "Playboy 百搭",
  "冰雪猛虎": "冰雪猛虎",
  "王牌Hilo": "王牌Hilo",
  "雷霆万钧猎风战士": "雷霆万钧猎风战士",
  "金罐钓钓乐圣诞版": "金罐钓钓乐圣诞版",
  "菲奥娜的圣诞财富": "菲奥娜的圣诞财富",
  "幸运双星 Link&Win": "幸运双星 Link&Win",
  "金罐钓钓乐升级版": "金罐钓钓乐升级版",
  "音速连接": "音速连接 ",
  "王牌Rummy": "王牌Rummy",
  "王牌PaiKang": "王牌Pai Kang",
  "罗宾汉英雄": "罗宾汉英雄",
  "深海行者": "深海行者",
  "星光水果": "星光水果",
  "翡翠勇士": "翡翠勇士",
  "亚马逊王国": "亚马逊王国",
  "小仙狐大冒险": "小仙狐大冒险",
  "王牌PokDeng": "王牌Pok Deng",
  "金龙呈祥": "金龙呈祥",
  "埃及守护神": "埃及守护神",
  "777 电光火石": "777 电光火石",
  "闪电 X UP": "闪电 X UP",
  "幸运矮妖精集群奖金": "幸运矮妖精集群奖金",
  "不朽情缘视频宾果": "不朽情缘视频宾果",
  "阿蒙的面具": "阿蒙的面具",
  "神圣财富 - 赫利俄斯": "神圣财富 - 赫利俄斯",
  "王牌Gaple": "王牌Gaple",
  "野火灼金": "野火灼金",
  "⻢戏小丑累积奖金": "⻢戏小丑累积奖金",
  "猫咪咒语": "\t猫咪咒语",
  "百搭狂野浪漫": "百搭狂野浪漫",
  "闪电财富": "闪电财富",
  "25000鹰爪": "25000鹰爪",
  "现金与财富Megaways": "现金与财富 Megaways",
  "15个三叉戟": "15个三叉戟",
  "地下城与钻石": "地下城与钻石",
  "阿兹特克天降大奖": "阿兹特克天降大奖",
  "瓦尔哈拉的统治者": "瓦尔哈拉的统治者",
  "心动芭菲": "心动芭菲",
  "王牌 色碟": "王牌 色碟",
  "鬼狩夜樱": "鬼狩夜樱",
  "金罐钓钓乐": "金罐钓钓乐",
  "水晶之王": "水晶之王",
  "王牌鱼虾蟹": "王牌鱼虾蟹",
  "Jurassic Park:黄金": "Jurassic Park:黄金",
  "5星淘汰": "5星淘汰",
  "特工简·布隆德最大音量": "特工简·布隆德最大音量",
  "篮球巨星百搭": "篮球巨星百搭",
  "科迪亚克王国": "科迪亚克王国",
  "财富大爆炸": "财富大爆炸",
  "喝彩的旺财": "喝彩的旺财",
  "4钻石蓝调 Megaways": "4钻石蓝调 Megaways",
  "9 个烈焰面具 HyperSpins": "9 个烈焰面具 HyperSpins",
  "猫咪部落": "猫咪部落",
  "圣诞老婆婆之书": "圣诞老婆婆之书",
  "幸运鸡": "幸运鸡",
  "奥林匹斯编年史宙斯": "奥林匹斯编年史宙斯",
  "WWE摔角传奇": "WWE摔角传奇",
  "瑞龙献宝": "瑞龙献宝",
  "10000个愿望": "10000个愿望",
  "777皇家幸运轮": "777皇家幸运轮",
  "黑暗阴影": "黑暗阴影",
  "精灵传说": "精灵传说",
  "秘密行动-雪诺和塞布尔": "秘密行动-雪诺和塞布尔",
  "非洲 X UP": "非洲 X UP",
  "炼金财宝": "炼金财宝",
  "神奇 连环 阿波罗": "神奇 连环 阿波罗",
  "神奇连环宙斯": "神奇连环宙斯",
  "古代财富 Poseidon Megaways": "古代财富 Poseidon Megaways",
  "太空传奇-莱拉和叶莉昂": "太空传奇-莱拉和叶莉昂",
  "亚特兰蒂斯 崛起": "亚特兰蒂斯 崛起",
  "热血羽毛球": "热血羽毛球",
  "炽热猛犸象": "炽热猛犸象",
  "金龙财宝": "金龙财宝",
  "亚瑟王之书": "亚瑟王之书",
  "Oz之书": "Oz之书",
  "好运经纪人": "好运经纪人",
  "炸弹海盗": "炸弹海盗",
  "再抢银行 MEGAWAYS": "再抢银行 MEGAWAYS",
  "嘉年华大奖": "嘉年华大奖",
  "疯狂现金": "疯狂现金",
  "板球明星 Scratch": "板球明星 Scratch",
  "闪亮的圣诞节": "闪亮的圣诞节",
  "钻石之王": "钻石之王",
  "埃及古墓": "埃及古墓",
  "金翠绿": "金翠绿",
  "青龙出海豪华版": "青龙出海豪华版",
  "烈火锻金": "烈火锻金",
  "禁忌王座": "禁忌王座",
  "森林舞会": "森林舞会",
  "遗忘之岛Megaways": "遗忘之岛Megaways",
  "魔龙宝珠": "魔龙宝珠",
  "淘金者": "淘金者",
  "黄金公主": "黄金公主",
  "金色骏马": "金色骏马",
  "黄金地鼠": "黄金地鼠",
  "上流社会": "上流社会",
  "超猎黄金": "超猎黄金",
  "挖到宝": "挖到宝",
  "不可思议的气球机": "不可思议的气球机",
  "K歌乐韵": "K歌乐韵",
  "加德满都": "加德满都",
  "奥兹Oz传奇": "奥兹Oz传奇",
  "腰缠万贯": "腰缠万贯",
  "迷失拉斯维加斯": "迷失拉斯维加斯",
  "幸运锦鲤": "幸运锦鲤",
  "幸运富豪 Hyperspins": "幸运富豪 Hyperspins",
  "幸运双星接财神": "幸运双星接财神",
  "幸运双星百搭": "幸运双星百搭",
  "毛伊大乱斗": "毛伊大乱斗",
  "玛雅公主": "玛雅公主",
  "百万人鱼": "百万人鱼",
  "怪物爆炸": "怪物爆炸",
  "海王星宝藏狂野之海": "海王星宝藏狂野之海",
  "奥丁的财宝": "奥丁的财宝",
  "鬼狩": "鬼狩",
  "鬼狩加強版": "鬼狩加強版",
  "亚历山大女王": "亚历山大女王",
  "圣诞老人的百搭摩托车": "圣诞老人的百搭摩托车",
  "塞伦盖蒂黄金": "塞伦盖蒂黄金",
  "上海美女": "上海美女",
  "银色之海": "银色之海",
  "足球前锋": "足球前锋",
  "太阳系百搭符号": "太阳系百搭符号",
  "星尘": "星尘",
  "妹妹很饿": "妹妹很饿",
  "雷霆万钧之百搭闪电": "雷霆万钧之百搭闪电",
  "提基奖励": "提基奖励",
  "太阳神许珀里翁": "太阳神许珀里翁",
  "万达福娃捕鱼": "万达福娃捕鱼",
  "万达爆金捕鱼": "万达爆金捕鱼",
  "开心点心": "开心点心",
  "免佣金百家乐": "免佣金百家乐",
  "龙虎百家乐": "龙虎百家乐",
  "龙虎百家乐-花花公子": "龙虎百家乐-花花公子",
  "免佣金百家乐-花花公子": "免佣金百家乐-花花公子",
  "幸运双星PowerClusters": "幸运双星PowerClusters",
  "黄金闪电终极版": "黄金闪电终极版",
  "布鲁诺的加洛黄金Megaways": "布鲁诺的加洛黄金Megaways",
  "Playboy百搭": "Playboy百搭",
  "马戏小丑累积奖金": "马戏小丑累积奖金",
  "王牌色碟": "王牌色碟",
  "4钻石蓝调Megaways": "4钻石蓝调Megaways",
  "9个烈焰面具HyperSpins": "9个烈焰面具HyperSpins",
  "古代财富PoseidonMegaways": "古代财富PoseidonMegaways",
  "亚特兰蒂斯崛起": "亚特兰蒂斯崛起",
  "再抢银行MEGAWAYS": "再抢银行MEGAWAYS",
  "板球明星Scratch": "板球明星Scratch",
  "幸运富豪Hyperspins": "幸运富豪Hyperspins",
}

export default {
  ...game_cn,
  ...electronic_cn,
  ...fish_cn,
  ...porker_cn,
  ...mgdz_cn
}